export default {
    'A name is required': 'É obrigatório um nome',
    Age: 'Idade',
    'Total money spent, $': 'Dinheiro total gasto, $',
    Clients: 'Clientes',
    Income: 'Rendimento',
    'First name': 'Primeiro nome',
    'Last name': 'Apelido',
    Position: 'Posição',
    'Click para seleccionar': 'Clique para seleccionar',
    Notifications: 'Notificações',
    Yes: 'Sim',
    No: 'Não',
    'City, country': 'Cidade, País',
    Address: 'Endereço',
    Birthday: 'Aniversário',
    'Click to add tags': 'Clique para adicionar etiquetas',
    Notes: 'Notas',
    Reset: 'Reinicialização',
    Save: 'Guardar',
    'Top clients': 'Principais Clientes',
    'Money spent, $': 'Dinheiro gasto',
    '-- Not selected --': 'Não seleccionado',
    'Sales manager': 'Gerente de vendas',
    'Customer service': 'Serviço ao cliente',
    'General manager': 'Director Geral',
    New: 'Novo',
    Customer: 'Cliente',
    Supplier: 'Fornecedor',
    Discount: 'Desconto',
    'Old Buddy': 'Velho amigo',
    'Avid Supporter': 'Apoiante ávido',
    Date: 'Data',
    Payment: 'Pagamento',
    Purchase: 'Compra',
    Sum: 'Soma',
    Left: 'Esquerda',
    'Nothing on this day': 'Nada neste dia',
    Information: 'Informação',
    Statistics: 'Estatísticas',
    Transactions: 'Transacções',
    Customers: 'Clientes',
    Charts: 'Gráficos',
    'See all notifications': 'Ver todas as notificações',
    'Deposits News': 'Notícias de depósito',
    'Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...':
        'Caro cliente, informamos-lhe sobre as seguintes alterações: a partir de 24 de Setembro de 2018 todas as transacções (entrada e saída...',
    'Search Improved': 'Pesquisa melhorada',
    'Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...':
        'Caro cliente! Seguindo as últimas actualizações dos motores SeekMeEverywhere, a sua pesquisa tornou-se mais fiável e conveniente! Não...',
    'Transaction Reports': 'Relatórios de translações',
    'Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...':
        'Caro cliente, informamo-lo sobre uma alteração na data dos relatórios mensais de transacções. A partir de 20 de Setembro de 2018, relatórios...',
    Advertência: 'Advertência',
    'Dear client, we know where you store your passwords. We highly recommend you to memorize them and destroy those memos of yours.':
        'Caro cliente, sabemos onde guarda as suas palavras-passe. Recomendamos-lhe vivamente que as memorize e destrua esses seus memorandos',
    'Edição de dados de clientes': 'Edição de dados de clientes',
    'Dear client, if you want to see the details on every customer and edit them, double-click the customer in the list on the right.':
        'Caro cliente, se quiser ver os detalhes de cada cliente e editá-los, faça duplo clique no cliente da lista à direita',
    'We miss you': 'Sentimos a sua falta',
    'Dear client, it has been a while since you talked to us. We are waiting for you in the same place at the same time.':
        'Caro cliente, já há algum tempo que não falava connosco. Esperamos por si no mesmo lugar e ao mesmo tempo',
    'Have a nice day': 'Tenha um bom dia',
    'Dear client, whenever you are reading this, we wish you a merry day. May the luck and success attend you.':
        'Caro cliente, sempre que estiver a ler isto, desejamos-lhe um dia feliz. Que a sorte e o sucesso o acompanhem',
    Localization: 'Localização',
    'Dear client, you can pick one of the six languages we provided for this demo app. Click the icon in the top right corner.':
        'Caro cliente, pode escolher uma das seis línguas que fornecemos para esta aplicação de demonstração. Clique no ícone no canto superior direito',
    'We love you': 'Nós amamos-te',
    'Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.':
        'Caro cliente, gostamos muito de si. Se os nossos sentimentos são mútuos, contacte-nos e descarregue Webix. Então iremos amá-lo eternamente',
    Persons: 'Pessoas',
    'Click twice to see more goodies': 'Clique duas vezes para ver mais guloseimas',
    Saved: 'Guardado',
    Settings: 'Configurações',
    'Regional settings': 'Definições regionais',
    Language: 'Idiomas',
    'Date format': 'Formato da data',
    'Money format': 'Formato do dinheiro',
    'Environment settings': 'Definições ambientais',
    Theme: 'Tema',
    Light: 'Claro',
    Dark: 'Escuro',
    'Max list length': 'Comprimento máximo da lista',
    'Default settings': 'Configurações predefinidas',
    'Open latest notifications': 'Abrir as últimas notificações',
    'Go to settings': 'Ir para definições',
    All: 'Todos',
    Payments: 'Pagamentos',
    Incoming: 'Entrada',
    Email: 'Email',
    Widgets: 'Widgets',
    Demos: 'Demonstrações',
    Prices: 'Preços',
    Tutorials: 'Tutoriais',
    'Tirane, Albania': 'Tirane, Albânia',
    'Buenos Aires, Argentina': 'Buenos Aires, Argentina',
    'Canberra, Australia': 'Camberra, Austrália',
    'Vienna, Austria': 'Viena, Áustria',
    'Minsk, Belarus': 'Minsk, Bielorrússia',
    'Brussels, Belgium': 'Bruxelas, Bélgica',
    'Brasilia, Brazil': 'Brasília, Brasil',
    'Ottawa, Canada': 'Ottawa, Canadá',
    'Beijing, China': 'Pequim, China',
    'Prague, Czech Republic': 'Praga, República Checa',
    'Copenhagen, Denmark': 'Copenhaga, Dinamarca',
    'Cairo, Egypt': 'Cairo, Egipto',
    'Helsinki, Finland': 'Helsínquia, Finlândia',
    'Paris, France': 'Paris, França',
    'Tbilisi, Georgia': 'Tbilissi, Geórgia',
    'Berlin, Germany': 'Berlim, Alemanha',
    'New Delhi, India': 'Nova Deli, Índia',
    'Dublin, Ireland': 'Dublin, Irlanda',
    'Rome, Italy': 'Roma, Itália',
    'Tokyo, Japan': 'Tóquio, Japão',
    'Wellington, New Zealand': 'Wellington, Nova Zelândia',
    'Seoul, Republic of Korea': 'Seul, República da Coreia',
    'Madrid, Spain': 'Madrid, Espanha',
    'Stockholm, Sweden': 'Estocolmo, Suecia',
    'Washington, United States': 'Washington, Estados Unidos da América',
    'Payment History': 'Histórico de pagamentos',
    'Origin of clients': 'Origem dos clientes',
    'Income from various age groups': 'Rendimento de várias faixas etárias',
    'Awarded Badges': 'Distintivos premiados',
    'Clients by occupation': 'Clientes por profissão',
    'No new notifications': 'Sem novas notificações',
    'Añadir Egreso': 'Acrescentar despesa',
    'Añadir Ingreso': 'Acrescentar rendimentos',
    'Saldo Recargas': 'Recarga de saldo:',
    'Saldo Juego:': 'Balanço do jogo:',
    Nombre: 'Nome',
    Hoy: 'Hoje',
    Ayer: 'Ontem',
    'Ultimos 30 días': 'Últimos 30 dias',
    Depósitos: 'Depósitos',
    Retiros: 'Saque',
    Neto: 'Net',
    'Advertencia!': 'Advertência!',
    'Desea cambiar la contraseña?': 'Deseja alterar a senha?',
    Salir: 'Cancelar',
    Descripción: 'Descrição',
    Activado: 'Activado',
    Inactivado: 'Inactivado',
    'Número de usuario': 'Número de usuário',
    'Login para acceso': 'Login para acesso',
    'Última dirección IP': 'Última direcção IP',
    'Último usuario modif': 'Último usuário modif',
    Tipo: 'Tipo',
    Agente: 'Agente',
    Afiliado: 'Afiliado',
    'Click para seleccionar': 'Clique para seleccionar',
    Estado: 'Estado',
    Activo: 'Activo',
    Inactivo: 'Inactivo',
    Retirado: 'Retirado',
    'Idioma preferido': 'Língua preferida:',
    'Nombre del usuario': 'Nome de usuário',
    País: 'País',
    'Campo Requerido': 'Campo Requerido',
    Moneda: 'Moeda',
    'Fecha de creación': 'Data de criação',
    'Última Fecha modif': 'Data da Última Modificação',
    'Estado Especial': 'Estado Especial',
    Pinagent: 'Pinagente',
    'Bloqueado para ventas': 'Bloqueado para vendas',
    'Imprime recibo caja': 'Imprimir caixa de recibos',
    'Permite recargas': 'Permitir depósitos',
    'Permite activar reg': 'Permitir a activação de reg',
    'Nombre del contacto': 'Nome de contacto',
    'Correo electrónico': 'Email',
    Teléfono: 'Teléfono',
    Concesionario: 'Concesionario',
    Subconcesionario: 'Subconcesionario',
    'Provincia/Región': 'Província / Região',
    Dirección: 'Endereço',
    Barrio: 'Bairro',
    'Limite diario de recargas': 'Limite diário de recargas',
    'Comisión recargas': 'Comissão de Depósito',
    'Apuesta mínima': 'Aposta mínima',
    'Límite diario': 'Limite diário',
    'Datos Principales': 'Dados Principais',
    'Datos Agente': 'Dados de Agente',
    'Datos Configuracion': 'Dados de Configuração',
    Limpiar: 'Reiniciar',
    Guardar: 'Guardar',
    'Completa los campos...': 'Complete os campos...',
    'Mi Información': 'A Minha Informação',
    'Contraseña Actual': 'Senha actual',
    'Nueva Contraseña': 'Nova senha',
    'The password must contain a minimum of 8 characters, a lowercase, an uppercase and a number.':
        'A senha deve conter um mínimo de 8 caracteres, uma minúscula, uma maiúscula e um número',
    'Confirmar Contraseña': 'Confirmar senha',
    'Contraseñas no coinciden': 'As senhas não coincidem',
    'Contraseña cambiada satisfactoriamente': 'Senha alterada com sucesso',
    '¡Exito!': 'Sucesso!',
    'Nueva contraseñas no coinciden': 'Novas senhas não coincidem',
    'Verifique los campos...': 'Verificar os campos...',
    'Cambiar mi contraseña': 'Alterar a minha senha',
    Slug: 'Slug',
    Superior: 'Superior',
    'Editar Categoría': 'Categoria de edição',
    Cancelar: 'Cancelar',
    'Categoría editada': 'Categoria editada',
    'Añadir Categoría': 'Adicionar Categoria',
    'Categoría Agregada': 'Categoria Adicionada',
    Todos: 'Todos',
    'Filtros Avanzados': 'Filtros Avançados',
    Consultar: 'Aplicar',
    Categoría: 'Categoria',
    Productos: 'Produtos',
    'Agregar Categoría Producto': 'Adicionar Categoria de Produto',
    'Categoría Producto Editada': 'Categoria de Produto Editado',
    'Editar Categorias Productos': 'Editar Categorias de Produtos',
    'Categoría Producto Agregada': 'Categoria de Produto Adicionado',
    Categorías: 'Categorias',
    'Añadir Categoría Producto': 'Adicionar Categoria de Produto',
    'Nombre Encargado': 'Nome do Responsável',
    Nit: 'Nit',
    'Es propio??': 'É teu?',
    'Añadir Tipo Producto Partner': 'Adicionar tipo de produto sócio',
    'Partner Agregado': 'Sócio Acrescentado',
    'Añadir Partner': 'Adicionar Sócio',
    Producto: 'Produto',
    Proveedor: ' Fornecedor',
    Partner: 'Sócio',
    Verificado: 'Verificado',
    'Filtro País': 'Filtro de país',
    Mobile: 'móvel',
    Escritorio: 'Ambiente de trabalho',
    Máximo: 'Máximo',
    Mínimo: 'Mínimo',
    'Tiempo Procesamiento': 'Tempo de processamento',
    Orden: 'Ordem',
    'Orden Destacado': 'Ordem em Destaque',
    Filas: 'Linhas',
    Columnas: 'Colunas',
    'Editar Productos Partner': 'Editar produtos de sócios',
    'Producto Partner Editado': 'Produto Editado de sócio',
    'Añadir Producto Partner': 'Adicionar produto de sócio',
    'Producto Partner Agregado': 'Produto de sócio acrescentado',
    Dispositivo: 'Device',
    Editar: 'Editar',
    Detalle: 'Detalhe',
    'Editar Partner': 'Editar sócio',
    Provedores: 'Fornecedores',
    'Proveedor Partner Agregado': 'Fornecedor sócio adicionado',
    'Proveedor Partner Editado': ' Fornecedor Sócio Editado',
    Imagen: 'Imagem',
    'Imagen URL': 'Imagem URL',
    'ID Externo': 'ID externo',
    Visible: 'Visível',
    'Producto Id': 'Identificação do Produto',
    'Editar Produto': 'Editar Produto',
    'Añadir Producto': 'Adicionar Produto',
    Abreviado: 'Abreviado',
    'Proveedor Id': 'Identificação de Fornecedor',
    Ambos: 'Ambos',
    'ID Usuario': 'ID Usuário',
    'Usuario (Correo electrónico)': 'Usuário (Email)',
    Apellido: 'Apelido',
    Documento: 'Documento',
    'Estado de Registro': 'Estado de Registo',
    Rechazado: 'Rejeitado',
    Bloqueado: 'Bloqueado',
    'Fecha de ultimo login': 'Última data de login',
    'Codigo Promocional': 'Código Promocional',
    'Desea activar registro?': 'Deseja activar o registo?',
    'Activar registro': 'Activar o registo',
    'Ocurrio un error, comuniquese con soporte': 'Ocorreu um erro, apoio de contacto',
    'Não pode activar um registo já actualizado': 'Não pode activar um registo já actualizado',
    'Desea rechazar registro?': 'quer recusar a inscrição?',
    'Rechazar registro': 'Rejeitar registo',
    Error: 'Erro',
    '¡Error!': '¡Erro!',
    'Medio de Registro': 'Meios de Registo',
    'Sub Categoría': 'Subcategoria',
    'Fecha final de la autoexclusión': 'Data final da auto-exclusão',
    'Usuario Creación': 'Criação do usuário',
    'Usuario Modificó': 'Utilizador Modificado',
    Juego: 'Jogo',
    'Tipo saldo': 'Tipo de saldo',
    'Saldo recargas': 'Recharge saldo',
    'Saldo retiros': 'Saldo de retiradas',
    Detalles: 'Detalhes',
    Historial: 'Histórico',
    None: 'Nenhum',
    Cancelado: 'Cancelado',
    'Añadir Ajuste': 'Adicionar configuração',
    'Nombre Usuario': 'Nome do usuário',
    Movimiento: 'Movimento',
    Entrada: 'Entrada',
    Salida: 'Output',
    Cancelación: 'Cancelamento',
    Valor: 'Valor',
    Respuesta: 'Resposta',
    Abierto: 'Aberto',
    Cerrado: 'Fechado',
    'Detalles del Ticket': 'Detalhes do bilhete',
    'Ticket Det Id': 'Ticket Det Id',
    'Ticket ID': 'identificação do bilhete',
    Market: 'Mercado',
    Fecha: 'Data',
    'Transacción ID': 'Identificação da transacção',
    Monto: 'Quantia',
    'Historial de Transacciones': 'História das Transacções',
    Usuario: 'Utilizador',
    Premios: 'Ganhos',
    Pendiente: 'Pendente',
    Redimido: 'Redimido',
    Expirado: 'Expirado',
    Libre: 'Livre',
    Deposito: 'Depósito',
    'No Deposito': 'Sin depósito',
    'Partner Bono Id': 'Identificação do bónus de Sócio',
    'Bono ID': 'ID Bônus',
    'ID Cliente': 'ID Cliente ',
    'Id Bono': 'ID Bônus',
    'Nombre de Bono': 'Nome do bónus',
    'Fecha Aceptación': 'Aceitação de data',
    'Fecha Modificación': 'Data de Modificação',
    'Monto Convertido': 'Valor convertido',
    'Rollover Requerido': 'Rollover Requerido',
    Apostado: 'Apostado',
    Restante: 'Restante',
    'Fecha Expiración': 'Data de Expiração',
    Apuestas: 'Apostas',
    Ganancias: 'Rendimentos',
    'Premios Bonos': 'Prémios de Bónus',
    'Beneficio %': 'Lucro %',
    'Nombre Sistema Pasarela Pago': 'Nome do Sistema de Portal de pagamento.',
    Pagada: 'Pago',
    Rechazada: 'Rejeitado',
    Detallado: 'Detalhado',
    Totales: 'Totais',
    'Resumen Financiero': 'Resumo Financeiro',
    'Ajustar Saldo': 'Ajustar saldo',
    'Usuario Id': 'Identificação do usuário',
    'Tipo Saldo': 'Tipo de saldo',
    Monto: 'Quantia:',
    'Transacción Id': 'Identificação da transacção',
    Ganó: 'Ganhou',
    Perdió: 'Perdido',
    'No Acción': 'Anulado',
    'En Espera': 'Waiting',
    'Rechazada por Regla': 'Rejeitado por Regra',
    'Pendiente por pagar Punto de venta': 'Pendente a pagar - Ponto de venda',
    'Retiro Voluntario': 'Retirada',
    'Dirección IP': 'Última direcção IP',
    Odds: 'Probabilidades',
    'Cambiar Contraseña': 'Alterar Senha',
    Código: 'Código',
    'Gerar Ficha': 'Gerar Ficha',
    'Desbloquear usuário por senha': 'Desbloquear usuário por senha',
    Desbloquear: 'Desbloquear',
    'Ocorreu um erro': 'Ocorreu um erro',
    'Alterações Feitas': 'Alterações Feitas',
    'Estado do usuário': 'Estado do usuário',
    'Estado de contingência': 'Estado de contingência',
    'Contingência Desportiva': 'Contingência Desportiva',
    'Contingência do Casino': 'Contingência do Casino',
    'Contingência de Casino ao Vivo': 'Contingência de Casino ao Vivo',
    'Estado de Contingência Virtual': 'Estado de Contingência Virtual',
    'Estado de Contingência de Póquer': 'Estado de Contingência de Póquer',
    'Estado de Registo do Usuário': 'Estado de Registo do Usuário',
    'Identificação frontal verificada': 'Identificação frontal verificada',
    'Verified Back ID': 'Verified Back ID',
    'Nome do sistema de pagamento': 'Nome do sistema de pagamento',
    'ID de conta': 'ID de conta',
    Banco: 'Banco',
    'Número da conta bancária': 'Número da conta bancária',
    'Código Interbancário': 'Código Interbancário',
    'Tipo de conta': 'Tipo de conta',
    Poupanças: 'Poupanças',
    Corrente: 'Corrente',
    'Conta bancária editada com sucesso': 'Conta bancária editada com sucesso',
    'Formas de Pagamento': 'Formas de Pagamento',
    Dinheiro: 'Dinheiro',
    'Conta bancária': 'Conta bancária',
    'Cheque bancário': 'Cheque bancário',
    'Loja de apostas': 'Loja de apostas',
    Filtros: 'Filtros',
    'Seguridad Cambios': 'Alterações de Segurança',
    Exportar: 'Exportar',
    'Cuentas Bancarias': 'Contas Bancárias',
    'Total Depósitos': 'Depósitos totais',
    'Total Apuestas Deportivas': 'Apostas Desportivas Totais',
    'Total Ganancias Deportivas': 'Total de Ganhos Desportivos',
    'Total Apuestas Casino': 'Apostas Totais no Casino',
    'Ganancias Totales Casino': 'Ganhos totais do Casino',
    'Total Retiros': 'Total Saque',
    'Total Ajustes Entrada': 'Definições de entrada total',
    'Total Ajustes Salida': 'Configurações de saída total',
    'Detalles Avanzados': 'Detalhes Avançados',
    Guardado: 'Guardado',
    'Erro!': 'Erro!',
    'Acrescentar conta': 'Acrescentar conta',
    'Editar conta': 'Editar conta',
    'Conta Actualizada': 'Conta Actualizada',
    'Conta Acrescentada': 'Conta Acrescentada',
    Gerente: 'Gerente',
    'Adicionar Área': 'Adicionar Área',
    'Editar Área': 'Editar Área',
    'Área Actualizado': 'Área Actualizada',
    'Área Agregado': 'Área adicionada',
    'Datos no han podido ser cargados': 'Os dados não puderam ser carregados',
    'Hora Inicio': 'Hora de início',
    'Hora Cierre': 'Hora de Fechamento',
    'ID Plan de Cuentas': 'ID do Plano de Conta',
    Referencia: 'Referência',
    'Añadir Concepto': 'Adicionar Conceito',
    'Plan de cuenta': 'Plano de contas',
    'Cuenta Id': 'Identificação da conta',
    'Editar Concepto': 'Edit Concept',
    'Concepto Actualizado': 'Conceito Actualizado',
    'Concepto Agregado': 'Conceito acrescentado',
    'Tipo de Centro': 'Tipo de Centro',
    'Añadir Centro': 'Adicionar Centro',
    'Editar Centro': 'Centro de edição',
    'Centro Actualizado': 'Centro Actualizado',
    'Centro Agregado': 'Centro Adicionado',
    Área: 'Área',
    Cargo: 'Posição',
    'Añadir Empleado': 'Adicionar Empregado',
    'Tipo Documento': 'Tipo de documento',
    Cedula: 'Identificação de documentos',
    'Cedula de extrangería': 'Cartão de Registo de Estrangeiro',
    Pasaporte: 'Passaporte',
    Salario: 'Salário',
    'Empleado Agregado': 'Adicionar Empregado',
    'Editar Empleado': 'Editar Empregado',
    'Empleado Actualizado': 'Empregado Actualizado',
    Consecutivo: 'Consecutivo',
    'Tarjeta de crédito': 'Cartão de crédito',
    'Tipo de Egreso': 'Type de Egress',
    'Documento ID': 'Identificação do documento',
    'Centro de Costos': 'Centro de Custos',
    Concepto: 'Conceito',
    Creador: 'Criador',
    Impuesto: 'Imposto',
    Retracción: 'Retracção',
    'Añadir Gasto': 'Adicionar despesas',
    'Es punto de venta?': 'É um ponto de venda?',
    'Gasto Agregado': 'Despesa adicional',
    Factura: 'Factura',
    'Editar Gasto': 'Editar Despesa',
    'Gasto actualizado': 'Gasto actualizado',
    'Tipo de ingreso': 'Tipo de rendimento',
    Cuenta: 'Conta',
    Soporte: 'Suporte',
    'Ingreso Agregado': 'Rendimento Acrescentado',
    'Ingreso Actualizado': 'Rendimento Actualizado',
    'Añadir Cargo': 'Adicionar Carga',
    'Tipo Cargo': 'Tipo Carga',
    'Cargo Agregado': 'Carga adicionada',
    'Productos Internos?': 'Produtos internos?',
    'Añadir Producto Tercero': 'Adicionar Produto de Terceiros',
    'Cuenta Contable Ingreso': 'Conta de rendimentos',
    'Cuenta Contable Egreso': 'Despesas da conta de contabilidade',
    'Producto Interno?': 'Produto Interno?',
    'Tipo Interno': 'Tipo Interno',
    'Plan cuentas Apuestas Tickets Tiendas': 'Plan accounts Betting Tickets BetShops',
    'Plan cuentas Premios Tickets Tiendas': 'Accounts BetShops Awards Account Plan',
    'Plan cuentas Pagos notas de retiro': 'Plan accounts Payments withdrawal notes',
    'Plan de cuentas Recargas': 'Plano de contas Recarregamentos',
    'Editar Producto Tercero': 'Editar Produto de Terceiros',
    'Producto Tercero Agregado': 'Produto Agregado de Terceiros',
    'Producto Tercero Actualizado': 'Produto Actualizado de Terceiros',
    'Producto Terceros': 'Produto de terceiros',
    Añadir: 'Acrescentar',
    'Cuenta Contable': 'Conta Contabilística',
    Agregada: 'Agregado',
    'RUC - NIT': 'RUC - NIT',
    'Añadir Proveedor': 'Adicionar Fornecedor',
    'Proveedor Agregado': 'Fornecedor Agregado',
    'Proveedor Actualizado': 'Fornecedor actualizado',
    'Valor Entradas': 'Valor das entradas',
    'Valor Salidas': 'Saídas de Valor',
    Nivel: 'Nível',
    'Con Cajero': 'Com Caixa',
    Centro: 'Centro',
    'Añadir Tipo': 'Adicionar tipo',
    'Editar Tipo': 'Tipo de edição',
    'Tipo Actualizado': 'Tipo Actualizado',
    'Tipo Agregado': 'Tipo Agregado',
    'Plan de Cuentas': 'Plano de contas',
    Areas: 'Áreas',
    Empleados: 'Empregados',
    'Reporte de cierre de día': 'Relatório do dia de encerramento',
    Conceptos: 'Conceitos',
    Egresos: 'Despesa',
    'Reporte de Gastos': 'Relatório de despesas',
    Ingresos: 'Rendimentos',
    'Otros Ingresos': 'Outros rendimentos',
    Cargos: 'Taxas',
    'Producto Tercero': 'Produto de terceiros',
    'Producto Tercero Punto de Venta': 'Produto de Ponto de Venda de Terceiros',
    'Productos Terceros': 'Produtos de terceiros',
    'Productos Terceros Punto de Venta': 'Produtos de Ponto de Venda de Terceiros',
    'Reporte de Cuadre de día': 'Relatório de Cuadre de día',
    'Reporte de Cuadre de día 2': 'Relatório de Trimestre do Dia 2',
    Tipos: 'Tipos',
    'Añadir Tipos': 'Añadir Tipos',
    Afiliador: 'Afiliado',
    'No Procesado': 'Não processado',
    'Añadir Agente': 'Adicionar agente',
    'Estado Validación': 'Estado de Validação',
    Región: 'Região',
    Departamento: 'Departamento',
    Ciudad: 'Ciudad',
    Modificado: 'Modificado',
    '¿Qué desea realizar?': 'O que é que quer fazer?',
    'Traslado a Saldo Recargas': 'Transferência para Saldo Recarregável',
    'Traslado a Saldo Juego': 'Transferência para o equilíbrio do jogo',
    'Transferir a saldo Recargas a ': 'Transferência para equilíbrio Recarga para',
    Transferir: 'Transferência',
    'No Se ha realizado la transferencia. Comunicarse con soporte.':
        'A transferência não foi feita. Por favor contacte o apoio',
    'Se ha realizado la transferencia satisfactoriamente.': 'A transferência foi concluída com sucesso.',
    'Transferir a Saldo Juego a ': 'Transferir para o equilíbrio do jogo para',
    'Saldo Juego Actual': 'Balanço actual do jogo',
    'Saldo Recargas Actual': 'Balanço de Recarga Actual',
    'Saldo de Recargas': 'Balanço de Recarga',
    'Saldo de Juego': 'Saldo de Juego',
    'Confirmar Valor': 'Confirmar Valor',
    Recargar: 'Recargar',
    'Los montos no coinciden': 'As quantidades não correspondem',
    'Cupos Asignados': 'Cotas atribuídas',
    'Historial cambios de cupo': 'História das alterações de quotas',
    'Tipo Cupo': 'Tipo de cotas',
    Recargas: 'Recargas',
    'Tipo Transacción': 'Tipo de Transacção',
    'Asignado Por': 'Atribuído por',
    'Comisión Nivel 1': 'Comissão Nível 1',
    'Comisión Nivel 2': 'Comissão Nível 2',
    'Comisión Nivel 3': 'Comissão Nível 3',
    'Comisión Nivel 4': 'Comissão Nível 3',
    'Comisión Punto': 'Ponto da Comissão',
    'Editar Comisión': 'Comissão de edição',
    'Valores Editados': 'Valores editados',
    Mensual: 'Mensal',
    Diario: 'Diário',
    'Valor Base': 'Valor Base',
    Comision: 'Comissão',
    'Valor Pagado': 'Valor Pago',
    'External ID': 'Identificação externa',
    Pregunta: 'Pergunta',
    'Saldo Afiliados': 'Saldo Afiliados',
    'Desea pagar comisión en efectivo?': 'Deseja pagar a comissão em dinheiro?',
    'Comisión Pagada': 'Comissão Paga',
    'Desea abonar comisión a saldo recargas?': 'Quer pagar comissão sobre a recarga?',
    'Desea abonar comisión a saldo juego?': 'Deseja pagar comissão sobre o saldo do jogo?',
    'Desea abonar comisión a saldo afiliados?': 'Gostaria de pagar comissão aos saldos das afiliadas?',
    'Desea Aprobar Comisión': 'Desejos de aprovação da Comissão',
    'Aprobar Comisión': 'Aprovar a Comissão',
    'Comisión Aprobado': 'Comisión Aprobado',
    'Restricción IP': 'Restrição de PI',
    'Token Google': 'Token Google',
    'Token Local': 'Ficha Local',
    'No tienes un QR Configurado.': 'Não tem um QR Configurado',
    UserModifId: 'UserModifId',
    Comisiones: 'Comissões',
    'Apuestas Totales Liquidadas': 'Apostas liquidadas totais',
    'Deporte Profitness': 'Lucro do deporte',
    'Casino Profitness': 'Lucro do Casino',
    'Reporte de Retiros': 'Relatório de Saques',
    'Tipo de Apuesta': 'Tipo de Apuesta',
    'Apuestas Creadas': 'Apuestas Creadas',
    'Apuestas Cerradas': 'Apuestas Cerradas',
    'Apuestas Pagadas': 'Apuestas Pagadas',
    'Cantidad Tickets': 'Cantidad Tickets',
    Stake: 'Aposta',
    'Stake Promedio': 'Promedio de aposta',
    Payout: 'Pagamento',
    Bonos: 'Bônus',
    Bonos1: 'Bônus',
    'Fecha Creación': 'Data de criação',
    Pendientes: 'Pendente',
    'Bono Deposito': 'Bônus de depósito',
    'No Deposit Bonus': 'Bônus sem depósito',
    Freebet: 'Freebet',
    Presupuesto: 'Orçamento',
    Aprobado: 'Aprovado',
    'Responder Solicitud': 'Responder ao pedido',
    'Respuesta Generada': 'Respuesta Generada',
    'Envie una Respuesta': 'Enviar uma resposta',
    'Aprobar Solicitud': 'Aprovar Pedido',
    'Rechazar Solicitud': 'Rejeitar Pedido',
    Requisitos: 'Requisitos',
    'Historial de requisitos enviados': 'História dos requisitos apresentados',
    Requisito: 'Requisito',
    'Añadir Requisito': 'Adicionar requisito',
    'Tipo Usuario': 'Tipo de usuário',
    'Editar Requisito': 'Editar Requerimento',
    Nombre: 'Nome',
    'Tipo Usuario': 'Tipo de usuário',
    'Requisito Editado': 'Requisito Editado',
    'Requisito Agregado': 'Requisito Agregado',
    'Estadisticas Marketing': 'Estatísticas de Marketing',
    'Marketing Vs Registros': 'Marketing Vs Registos',
    'Top Usuarios': 'Top Usuários',
    Clave: 'Senha',
    'Datos Configuración': 'Configuração de Dados',
    'Reporte de Bonos': 'Relatório do bônus',
    'Reporte de Casino': 'Relatório do Casino',
    'Reporte de Comisiones': 'Relatório do Comissões',
    'Reporte de Comisiones Detallado': 'Relatório Detalhado das Comissões',
    'QR Google': 'QR Google',
    'Reporte de Bonos': 'Relatório do bônus',
    'Flujo de Caja': 'Fluxo de caixa',
    'Reporte de Flujo de Caja': 'Relatório de fluxo de caixa',
    'Flujo de caja hijos': 'Fluxo de caixa Filhos',
    'Reporte de Flujo de Caja Hijos': 'Relatório de de fluxo de caixa crianças',
    'Reporte de Apuestas': 'Relatório de aposta',
    'Flujo Caja Hijos': 'Fluxo de caixa Filhos',
    'Usuarios Afiliados': 'Usuários afiliados',
    Marketing: 'Marketing',
    Informe: 'Informe',
    'Códigos Promocionales': 'Códigos Promocionais',
    'Solicitudes de Agentes': 'Pedidos de Agente',
    'Ultimos 3 días': 'Últimos 3 dias',
    'Ultimos 7 días': 'Últimos 7 dias',
    'Añadir Punto': 'Adicionar Ponto',
    Login: 'Login',
    'Apuesta Total': 'Aposta Total',
    Latitud: 'Latitud',
    Longitud: 'Longitude',
    'Punto de venta Agregado': 'Ponto de venda agregado',
    'Editar Punto': 'Editar Ponto',
    Competencia: 'Concorrência',
    'Punto de venta actualizado': 'Ponto de Venda Atualizado',
    'Publicidad Punto': 'Punto Publicidade',
    'Añadir Publicidad': 'Adicionar Publicidade',
    'Añadir Publicidad Cajero': 'Adicionar Caixa de Publicidade',
    Cajeros: 'Caixas',
    'Añadir Cajero': 'Adicionar caixa',
    Ruta: 'Rota',
    'Publicidad Añadida': 'Publicidade agregada',
    'Editar Publicidad': 'Editar Publicidade',
    'Publicidad Actualizada': 'Atualização em Publicidade',
    'Publicidad Cajero Añadida': 'Publicidade Caixa Agregado',
    'Editar Publicidad Cajero': 'Editar  de Publicidade de Caixa',
    'Abrir Publicidad': 'Abrir Publicidade',
    'Computador ID': 'ID do computador',
    'Min Apuesta': 'Min Aposta',
    'Max Apuesta Live': 'Max Aposta Live',
    'Max Apuesta PreMatch': 'Max Aposta PreMatch',
    'Cajero Agregado': 'Caixa agregada',
    'Comisión Usuario': 'Caixa agregada',
    'por Abuelo': 'por avô',
    'por Padre': 'por Pai',
    'por Hijo': 'por Filho',
    'por Nieto': 'por Nieto',
    Total: 'Total',
    Total: 'Total',
    'Usuario REF': 'Usuário REF',
    'Fecha de Creación': 'Data de criação',
    'Pregunta ': 'Pergunta',
    'Seleccione el tipo de saldo': 'Selecione o tipo de balanço',
    'Saldo Recarga': 'Recarga de Balanço',
    'Ganancias sujetas a impuestos': 'Lucros tributáveis',
    'Valor Apostado': 'Valor do Aposto',
    'Valor Premio': 'Valor Prêmio',
    Ganancia: 'Lucro',
    'La contraseña debe contener mínimo 6 caracteres y un número, un carácter no se puede repetir más de 3 veces consecutivamente ':
        'The password must contain minimum 6 characters and a number, a character cannot be repeated more than 3 times consecutively ',
    'Fecha ultima detección': 'Data da última detecção',
    Plataforma: 'Platforma',
    'Nombre Archivo': 'Nome do arquivo',
    'Hash Original': 'Hash Original',
    'Hash Detectado': 'Hash Detectado',
    'Fecha modificación': 'Data da modificação',
    'Reporte de Hash': 'Relatório de Hash',
    Tecnología: 'Tecnologia',
    Financiero: 'Financeiro',
    'Filtrar Tabla': 'Filtrar Tabela',
    'Dirigido al Departamento': 'Dirigido ao Departamento',
    'Título de la petición': 'Título da petição',
    Título: 'Título',
    'Generar Petición': 'Gerar Pedido',
    Generar: 'Generar',
    'Añadir Respuesta': 'Adicionar resposta',
    'Respuestas de la petición': 'Respostas à petição',
    'La petición debe estar activa': 'A petição deve estar ativa',
    Acción: 'Ação',
    'Usuario Creo': 'Usuário eu acredito',
    'Desea cerrar la petición?': 'Você deseja encerrar a petição?',
    'Cerrar Peticíon': 'Fechar petição',
    'Estado de petición actualizada': 'Status da petição atualizada',
    'Desea Activar la petición?': 'Você quer Ativar a petição?',
    'Activar Peticíon': 'Ativar petição',
    'Responder Petición': 'Resposta petição',
    Peticiones: 'Petições',
    'Mensaje Id': 'Identificação da mensagem',
    Casino: 'Cassino',
    'Live Casino': 'Cassino ao Vivo',
    'Añadir Mensaje': 'Adicionar mensagem',
    'Editar Mensaje': 'Editar mensagem',
    Mensaje: 'Mensagem',
    Asunto: 'Assunto',
    Emisor: 'Emissor',
    Receptor: 'Receptor',
    Leido: 'Leia',
    Mensajes: 'Messages',
    'Tipo de Producto': 'Tipo de produto',
    'Fecha Inicio': 'Data de início',
    'Fecha Fin': 'Data Fim',
    'Añadir Liga': 'Adicionar Liga',
    Resultados: 'Resultados',
    'Fecha del ultimo logueo': 'Data do último login',
    'Reporte de Apuestas Deportivas': 'Data do último login',
    Usuarios: 'Usuários',
    'Tabla de Resultados': 'Tabela de resultados',
    Nro: 'Nro',
    Puntuación: 'Pontuação',
    'Saldo Actual de usuarios por Edades': 'Balanço atual do usuário por idade',
    Deportivo: 'Esportivo',
    Si: 'Esportivo',
    'Liga Agregada Correctamente': 'Liga Corretamente Adicionada',
    'La Fecha de inicio debe ser menor a la fecha fin.': 'A data de início deve ser menor que a data final',
    'Añadir Liga': 'Adicionar Liga',
    'Segundo Nombre': 'Segundo nome',
    Notificaciones: 'Notificações',
    'Lista de Ligas': 'Lista de Ligas',
    Información: 'Informação',
    Reportes: 'Reportes',
    Configuración: 'Configuração',
    'Reporte de Usuarios': 'Relatório de usúarios',
    'Publicidad Máquina': 'Publicidade Máquina',
    'Id Nota de Retiro': ' ID Nota de Saque',
    'Valor a pagar': 'Valor a ser pago',
    'Premio Proyectado': 'Prêmio Projetado',
    Ganador: 'Vencedor',
    'Pagar Nota Retiro': 'Retirada de nota de pagamento',
    'No. Ticket': 'No. Bilhete',
    'Clave Ticket': 'Código',
    'Pagar Premio': 'Prêmio de pagamento',
    Encendida: 'Encendida',
    Apagada: 'Fora',
    'Usuario Actualizó': 'Atualização de usuário',
    'Reporte de Logs': 'Relatório de Logs',
    'Reporte de Actualizaciones': 'Relatório de atualização',
    'Actualizar Versión ': 'Versão de atualização',
    Vinculo: 'Link',
    Actualizar: 'Atualização',
    'Actualizar Ambos': 'Atualizar ambos',
    'Enviar Comando a ': 'Enviar comando para',
    Enviar: 'Enviar',
    'Tipo Establecimiento': 'Tipo de estabelecimento',
    Versión: 'Versão',
    'Documento 1': 'Documento 1',
    'Documento 2': 'Documento 2',
    'Añadir Traducción': 'Adicionar Tradução',
    'Traducción Agregada': 'Tradução agregada',
    'Editar Traducción': 'Editar Tradução',
    'Traducción Editada': 'Traducción Editada',
    'Obtener URL': 'Obtener URL',
    'Subir Imagen': 'Subir Imagen',
    'Primer nombre': 'Primeiro nome',
    'CashDesk Name': 'Nome do CashDesk',
    Hora: 'Tempo',
    'Usuario que lo creo': 'Usuário que o criou',
    'Tipo:': 'Tipo:',
    'Descripción:': 'Descrição:',
    'Valor:': 'Valor:',
    'Ingreso por tarjeta de crédito añadido satisfactoriamente': 'Renda de cartão de crédito acrescentada com sucesso',
    'Seleccione tipo de factura': 'Seleccione tipo de factura',
    POS: 'POS',
    CARTA: 'CARTA',
    'Nro. Documento': 'No. Documento',
    'Proveedor Tercero': 'Fornecedor Tercero',
    'Concepto:': 'Conceito:',
    'Nro. Documento': 'No. Documento',
    'Proveedor Tercero': 'Fornecedor Tercero',
    'Error, comuniquese con soporte.': 'Erro, favor contatar o suporte.',
    'Egreso añadido satisfactoriamente': 'Saída acrescentada com sucesso',
    'Proveedor Tercero': 'Fornecedor Tercero',
    'Ingreso añadido satisfactoriamente': 'Renda acrescentada de forma satisfatória',
    'Dinero Inicial:': 'Dinheiro inicial:',
    'Total Ingresos:': 'Rendimento total:',
    'Total Egresos:': 'Gastos totais:',
    'Ingresos Tarjeta Credito:': 'Renda Cartão de crédito',
    'Verifique que todos los datos sean validos ': 'Verificar se todos os dados são válidos',
    'Forma Pago 1': ' Forma de pagamento 1',
    'Pago Bono \/ T.C.': 'Pagamento de bônus \/ T.C',
    'Valor Entradas Efectivo': 'Valor Influxos de dinheiro',
    'Valor Entradas Bono \/ T.C.': 'Valor Bilhetes-Bônus \/ T. C.',
    'Valor Entradas Traslados': 'Valor dos ingressos Transferências',
    'Valor Entradas Recargas': 'Valor dos ingressos Recarga',
    'Valor Salidas Efectivo': 'Saídas de valor em dinheiro',
    'Valor Salidas Traslados': 'Valor Partidas Transferências',
    'Valor Salidas Notas de Retiro': 'Valor Saídas Notas de Saque',
    'V.Entradas Efectivo': 'V.Entrada de dinheiro',
    'V.Entradas Efectivo Neto': 'V.Influxos de dinheiro Net',
    'V.Entradas Bono/T.C': 'V.Ingressos Vouchers \/ T. C.',
    'V.Entradas Traslados': 'V.Ingressos Transferências',
    'V.Entradas ': 'V.Ingressos',
    'V.Salidas Efectivo': 'V.Saídas Dinheiro',
    'V.Salidas Efectivo Neto': 'V.Saídas Dinheiro Net',
    'V.Salidas Traslados': 'V.Saídas Transferências',
    'V.Salidas N.Retiro': 'V.Saídas N.Saque',
    Saldo: 'Balanço',
    'Pagada?': 'Pago?',
    'Numero del cliente:': 'Número do cliente:',
    'Cedula del cliente:': 'Cartão de identificação do cliente:',
    'Email del cliente:': 'Endereço eletrônico do cliente:',
    'Campo No Valido': 'Campo não válido',
    'Filtre Mínimo por un campo': 'Filtro Mínimo por um campo',
    'Nro. de Cliente:': 'Nº do cliente:',
    'Nombre del Cliente:': 'Nome do cliente:',
    'País:': 'País:',
    'Moneda:': 'Moeda:',
    'Valor a Recargar:': 'Valor para recarregar:',
    'Desea Realizar la Recarga?': 'Você quer recarregar?',
    'Ocurrio un error...': 'Ocorreu um erro...',
    'Recarga Completada Satisfactoriamente': 'Recarga Satisfatoriamente Completada',
    'Añadir Competidor': 'Adicionar Concorrente',
    Competidores: 'Concorrentes',
    'Competidor Agregado': 'Concorrente Agregado',
    'Editar Competidor': 'Editar Concorrente',
    'Competidor Editado': 'Concorrente Editado',
    'Fecha de creación:': 'Data de criação:',
    'Nombre de Usuario:': 'Nome do usuário:',
    'Valor de la nota:': 'Valor da nota:',
    'Eliminar Nota': 'Eliminar Nota',
    'ID Nota de Retiro:': 'Identificação da Nota de Retirada:',
    'Observaciones:': 'Observações:',
    'Nro Nota Retiro:': 'Nº Nota Retirada:',
    'Nro Usuario:': 'Nº de usuário:',
    'Fecha Eliminación': 'Data Eliminação',
    'Nombre del Usuario:': 'Nome do usuário:',
    'Usuario que la Eliminó:': 'Usuário que o apagou:',
    'Nota de data': 'Date Note',
    'Nro Nota Retiro:': 'Nº Nota Retirada:',
    'Valor Nota': 'Nota de valor',
    Observaciones: 'Observações',
    'Historial de gestiones': 'Histórico de ações',
    'Fecha\/hora': 'Data\/Tempo',
    Texto: 'Texto',
    'Nota Generada': 'Nota Gerada',
    'Nombres:': 'Nomes:',
    'Apellidos:': 'Apelido:',
    'Teléfono:': 'Telefone:',
    'Skype:': 'Skype:',
    'Dirección:': 'Endereço:',
    'Email:': 'Email:',
    'Empresa:': 'Empresa:',
    'Empresa:': 'Empresa:',
    Provincia: 'Província',
    Observacion: 'Observação',
    'Fecha\/Hora Ultima Modif': 'Data\/Tempo Última Modif',
    'Usuario Ultima Modif': 'Usuário Última Modif',
    'Desea Terminar Gestión?': 'Você quer encerrar a gestão?',
    'Terminar Gestión': 'Gestão de Terminar',
    'Gestión Terminada satisfactoriamente. ': 'Gestão concluída com sucesso.',
    'Cedula de Ciudadania': 'Cartão de Cidadania',
    'Cedula de Extranjeria': 'Cartão de Registro de Estrangeiro',
    'Primer Nombre:': 'Primeiro Nome:',
    'Primer Nombre:': 'Primeiro Nome:',
    'Nro Documento:': 'Documento No:',
    'Nro Documento:': 'Documento No:',
    'Segundo Nombre:': 'Segundo Nome:',
    'Segundo Nombre': 'Segundo Nome',
    'Primer Apellido:': 'Primeiro Apelido:',
    'Primer Apellido': 'Primeiro Apelido',
    'Segundo Apellido:': 'Segundo Apelido:',
    'Segundo Apellido': 'Segundo Apelido',
    'Nro Cheque:': 'Cheque No.:',
    'Nro Cheque': 'Cheque No.',
    Origen: 'Origem',
    'Nota Retiro': 'Nota Retirada',
    Ticket: 'Bilhete',
    'Cliente:': 'Cliente:',
    Cliente: 'Cliente',
    'Documento Referente:': 'Documento de referência:',
    'Documento Referente': 'Documento relacionado a',
    'Doc. Cliente:': 'Doc. do Cliente:',
    'Doc. Cliente': 'Doc. Cliente',
    'Nro. Recarga:': 'Nro. recarregar:',
    'Nro. Recarga': 'Nro. recarregar',
    'Nro. Cliente:': 'Nro. Cliente:',
    'Nro. Cliente': 'Nro. Cliente',
    'Nombre Cliente:': 'Nome do Cliente:',
    'Nombre Cliente': 'Nome do Cliente',
    'Usuario Solicita': 'Solicitações do usuário',
    Campo: 'Campo',
    Antiguo: 'Antigo',
    Nuevo: 'Novo',
    Aprobadas: 'Aprovado',
    Rechazadas: 'Rejeitado',
    'Desea Rechazar el log?': 'Você quer Rejeitar o log?',
    'Rechazar log': 'Rejeitar log',
    'Estado de log actualizado': 'Status de registro atualizado',
    'Desea Aprobar el log?': 'Você quer aprovar o registro?',
    UserName: 'Nome de usuário',
    Listo: 'Pronto',
    Aprobada: 'Aprovado',
    'Tipo de usuario': 'Tipo de usuário',
    'Administrador General': 'Administrador Geral',
    'Administrador Secundario': 'Administrador Secundário',
    Operador: 'Operador',
    'System Administrator': 'Administrador de sistema',
    Consultas: 'Consultas',
    'ADMIN AFILIADOS': 'FILIAIS ADMINISTRATIVAS',
    CUSTOM: 'CUSTOM',
    'Usuario de País': 'País Usuário',
    'Categoría cliente': 'Categoria do cliente',
    'Añadir Usuario': 'Adicionar usuário',
    'Numero de Documento': 'Número do documento',
    Género: 'Gênero',
    Cumpleaños: 'Data de nascimento',
    'Está bloqueado?': 'Está bloqueado?',
    'País Residencia': 'País de residência',
    'Provincia\/Región Residencia': 'Província\/Região Residência',
    'Ciudad Residencia': 'Residência da cidade',
    'Código Zip': 'Código Postal',
    Celular: 'Móvel',
    'Fecha de registro': 'Data do registro',
    Perfil: 'Perfil',
    Página: 'Página',
    DíasCaducidadClave: 'DiasCaducidadeChave',
    'Menus no permitidos': 'Menus não permitidos',
    'Menus Permitidos': 'Menus Permitidos',
    ADMIN: 'ADMIN',
    ADMIN2: 'ADMIN2',
    'ADMIN AGGREGATOR': 'ADMIN AGGREGATOR',
    CAJERO: 'CAIXA',
    CONCESIONARIO: 'CONCESSIONÁRIO',
    CONCESIONARIO2: 'CONCESSIONÁRIO2',
    OPERADOR: 'OPERADOR',
    PUNTOVENTA: 'PONTOVENDA',
    CONSULTAS: 'ENQUIRIES',
    ADMINAFILIADOS: 'ADMINAFILIADOS',
    'Debe de seleccionar un usuario.': 'Você deve selecionar um usuário.',
    Menu: 'Menu',
    Submenu: 'Submenu',
    Adicionar: 'Adicione',
    'Cedula Nacional': 'Cédula de Identidade Nacional',
    'Cedula Extranjera': 'Cédula de identidade estrangeira',
    Trabajador: 'Trabalhador',
    'Familiar Trabajador': 'Membro da família Trabalhador',
    'Añadir Usuario a Bloquear': 'Adicionar usuário ao bloco',
    'Usuario Asociado': 'Usuário Associadol',
    Regional: 'Regional',
    'Tipo Punto': 'Tipo Ponto',
    Partners: 'Partners',
    'Recargar Credito': 'Recarregar crédito',
    'Torneos y Bonos': 'Torneios e Bônus',
    'Mi Configuracion': 'Minha configuração',
    'Partners Proveedores': 'Partners Fornecedores',
    'Partners Tipo Producto': 'Partners Tipo produto',
    'Partners Productos': 'Partners Produto',
    'Partners Productos Pais': 'Partners Produtos País',
    Categorias: 'Categorias',
    'Categorías Productos': 'Categorias Produtos',
    Jugadores: 'Jogadores',
    'Jugadores Partner': 'Jogadores Partner',
    'Jugadores Aggregator': 'Jogadores Aggregator',
    'Reporte de depósitos': 'Relatório de depósito',
    'Autoexclusiones de Usuario': 'Auto-exclusões do usuário',
    'Reporte de casino': 'Relatório do cassino',
    'Reporte de Saldos': 'Relatório de balanço',
    'Reporte de bonos': 'Relatório de bônus',
    'Reporte de Jugadores': 'Relatórios dos jogadores',
    'Flujo de Caja Histórico': 'Fluxo de caixa histórico',
    'Flujo de Caja Resumido': 'Fluxo de caixa resumido',
    'Informe Gerencial': 'Relatório gerencial',
    'Usuario online Resumido': 'Usuário Online Resumido',
    'Usuario - Agregator': 'Usuário - Agregator',
    'Premios pendientes por pagar': 'Prêmios pendentes a pagar',
    'Reporte de Sesiones': 'Relatório das sessões',
    'Reporte de Ajustes de Saldos': 'Relatório de ajuste de saldo',
    'Reporte Trans. Sportbook': 'Relatório  Trans. Sportbook',
    'Reporte de Movimientos Saldo': 'Relatório de Movimento Balanço',
    'Historico de Saldos': 'Histórico de balanço',
    'Documentos Registrados': 'Documentos Registrados',
    Contabilidad: 'Contabilidade',
    'Centros de costo': 'Centros de custo',
    Estructural: 'Estrutural',
    Cuentas: 'Contas',
    'Cierres de Caja': 'Fechamentos de caixa',
    Seguridad: 'Segurança',
    'Aprobar logs': 'Aprovar logs',
    'Usuarios administrativos': 'Usuários administrativos',
    'Usuarios Bloqueados': 'Usuários Bloqueados',
    Contingencia: 'Contingência',
    Menus: 'Menus',
    Perfiles: 'Perfis',
    'Perfiles - Options': 'Perfis - Opções',
    'Sub Menu': 'Sub Menu',
    'Usuario Perfil': 'Usuário Perfis',
    Gestion: 'Administração',
    'Codigos Promocionales': 'Códigos Promocionais',
    'Activar Registros': 'Ativar Registros',
    'Ajustar pasarela de pago': 'Ajustar Portal de pagamento',
    'Asignacion de cupo': 'Alocação de cotas',
    'Eliminar nota de retiro': 'Eliminar Nota do saque',
    'Manejar red': 'Gestão de rede',
    'Registro rapido': 'Registo rápido',
    'Reimprimir cheque': 'Reimpressão de cheque',
    Reversion: 'Reversão',
    'Trabaja con nosotros': 'Trabalhe conosco',
    Caja: 'Caixa',
    'Pago Premio': 'Pagamento Prêmio',
    'Pago Nota Retiro': 'Pagamento Nota do Saque',
    Lista: 'Lista',
    Maquinas: 'Maquinas',
    Registrar: 'Registrar',
    'Pago Nota de cobro': 'Pagamento Nota de cobrança',
    'Maquinas Grafica': 'Maquinas Grafica',
    Herramientas: 'Ferramentas',
    'Partner Ajustes': 'Partner Ajustes',
    Traducción: 'Tradução',
    'Subir imagen': 'Carregar imagem',
    'Gestión Punto de Venta': 'Administração Ponto de venda',
    'Gestión Puntos Gráfico': 'Administração Pontos Gráfico',
    'Puntos de venta Competencia': 'Pontos de venda Concorrência',
    Agentes: 'Agentes',
    'Lista de Agentes': 'Lista de agentes',
    'Árbol de Agentes': 'Árvore de Agente',
    'Informe de Agentes': 'Relatório de Agentes',
    Transferencias: 'Transferências',
    Solicitudes: 'Pedidos',
    'Solicitudes de Retiro': 'Pedidos de saque',
    'Solicitudes de Deposito': 'Pedidos de depósito',
    'Cierre de caja': 'Fechamento do caixa',
    'Inicio Día': 'Início Dia',
    'Fecha: ': 'Data: ',
    'Valor Inicio de día:': 'Valor Início do dia',
    'Agregar imagen': 'Adicionar imagem',
    'Añadir Proveedor Partner': 'Adicionar fornecedor Partner',
    'Proveedor Partner': 'Partner fornecedor',
    'Tipo Producto Partner': 'Tipo Produto Partner',
    'Saldo Depósitos:': 'Balanço Depósitos:',
    'Tipo de integración': 'Tipo de integração',
    'Pasarela de Pagos': 'Portal de pagamento',
    'Lobby con token propio': 'Lobby com seu próprio token',
    'Lobby con token de proveedor': 'Lobby com token do fornecedor',
    'Productos Partner': 'Produtos Partner',
    Automático: 'Automático',
    'Partners Productos País': 'Partners Produtos País',
    'Lista de Jugadores': 'Lista de Jogadores',
    Bloqueados: 'Bloqueados',
    'DNI Anterior': 'CPF Anterior',
    'No tiene DNI Anterior': 'Nenhum CPF Anterior',
    'DNI Posterior': 'Posterior CPF',
    'No tiene DNI Posterior': 'Nenhum CPF Posterior',
    Descargar: 'Descarregar',
    'Tipo de Documento': 'Tipo de documento',
    'Cedula de Extranjería': 'Cédula de identidade estrangeira',
    'Subir DNI Anterior': 'Carregar CPF anterior',
    'Subir DNI Posterior': 'Carregar CPF Posterior',
    Finanzas: 'Finanças',
    Resumen: 'Resumo',
    'Reporte Autoexclusión': 'Relatório de Auto-Exclusão',
    'Reporte de Sesiones': 'Relatório das sessões',
    'Registro de Documentos': 'Registro de documentos',
    'Ver más': 'Veja mais',
    'Historial de saldo': 'Histórico de saldo',
    'Historial de movimientos': 'Histórico do movimento',
    'Logs Usuario': 'Logs de usuário',
    'Valor Mínimo': 'Valor mínimo',
    'Valor Máximo': 'Valor máximo',
    'Premio Total Máximo': 'Prêmio Total Máximo',
    'Premio Total Mínimo': 'Prêmio Total Mínimo',
    'Crear Token Personalizado': 'Criar Token Personalizado',
    'Crear Token': 'Criar Token',
    Token: 'Token',
    'Token Creado': 'Token Criada',
    'Cancelar Cuenta': 'Cancelar conta',
    'Desea cancelar la cuenta de el usuario?': 'Você quer cancelar a conta do usuário?',
    'Resumen por Proveedor': 'Resumo por fornecedor',
    'Tipo Pasarela de Pago': 'Tipo Portal de pagamento',
    'Proveedor pasarela de pago': 'Fornecedor Portal de pagamento',
    'Usuarios Autoexcluidos': 'Usuários auto-excluídos',
    Cantidad: 'Quantidade',
    'Saldo Gratis': 'Saldo grátis',
    Envió: 'Enviado',
    'Reporte de Saldos Online': 'Relatório de saldo on-line',
    'Añadir bono a saldo': 'Adicionar bônus ao saldo',
    'Bono a saldo añadido correctamente': 'Bônus para saldo adicionado com sucesso',
    'Tipo de Detalle': 'Tipo de detalhe',
    Apuesta: 'Aposta',
    'Apuesta Promedio': 'Aposta Média',
    'Usuarios Registrados': 'Usuários Registrados',
    'Primeros Depósitos': 'Primeiros depósitos',
    'Usuario Id': 'Usuário ID',
    'Cant Tickets Casino': 'Quantidade Tickets Cassino',
    'Cant Tickets Casino Vivo': 'Quantidade Tickets Cassino ao Vivo',
    'Total Tickets': 'Total Tickets',
    'Saldo Disp Retiro': 'Saldo disponível de saque',
    'Nota de retiro pendiente': 'Pending Withdrawal Note',
    'Vlr Ap. Casino': 'Valor Aposta Cassino',
    'Vlr Ap. Casino Vivo': 'Valor Aposta Cassino ao Vivo',
    'Total Apostado': 'Total Apostado',
    'Vlr Pr. Casino': 'Cassino Prêmio Valor',
    'Vlr Pr. Casino Vivo': 'Prêmio Valor Cassino Ao vivo',
    'Total premios': 'Total Prêmio',
    'Saldo Recargas': 'Saldo Recarrega',
    'Valor Recargas': 'Valor Recarrega',
    'Valor premios': 'Value Prêmios',
    'Relación Usuario Aggregato': 'Relação Usúario Aggregato',
    'Usuario Partner': 'Usúario Partner',
    'Usuario Aggregator': 'Usúario Aggregator',
    'Añadir Relación': 'Añadir Relação',
    'Editar Relación': 'Editar Relação',
    'Hora de creación': 'Tempo de criação',
    'Fecha Premio': 'Data do prêmio',
    'Hora Premio': 'Tempo do prêmio',
    'Transacciones deportivas': 'Transações Sportbook',
    'Saldo Inicial': 'Saldo Inicial',
    'Ap. Deportivas': 'Apostas Sportbook',
    'Pr. Deportivas': 'Prêmios Sportbook',
    'Ap. Casino': 'Apostas Cassino',
    'Pr. Casino': 'Prêmios Cassino',
    'Retiros Creados': 'Saques Criados',
    'Retiros Eliminados': 'Saques Eliminados',
    'Ajustes E': 'Configurações E',
    'Ajustes S': 'Configurações S',
    'Saldo Final': 'Saldo final',
    'Saldo Final Calc.': 'Saldo Final Calculado',
    'Retiros Pagados': 'Saques Pagados',
    'Retiros Pendientes': 'Saques Pendentes',
    'Bonos Free Ganados': 'Bônus Grátis Ganhado',
    'Añadir Documento': 'Adicionar documento',
    'Editar Documento': 'Editar documento',
    'Puntos de Venta': 'Pontos de Venta',
    'Saldo Juego': 'Saldo Jogo',
    'Datos Punto de venta': 'Dados Ponto de venda',
    'Configuración Punto de Venta': 'Configuração Ponto de venda',
    Contraseña: 'Senha',
    'Forma de pago': 'Forma de pagamento',
    Modificó: 'Modificó',
    'Nombre del sistema de pasarela de pago': 'Nome do sistema de Portal de pagamento',
    'Tipo de tiempo': 'Tipo de tempo',
    Resultado: 'Resultado',
    'Fecha Resultado': 'Data Resultado',
    'Reporte Flujo de Caja': 'Relatório de fluxo de caixa',
    'Rollover Apostado': 'Rollover Apostado',
    'Rollover Restante': 'Rollover Restante',
    'Estado de Recarga': 'Estado de recarrega',
    'Actualizar IP': 'Atualização IP',
    'Punto de Venta:': 'Ponto de venda:',
    'ID Sesión': 'Sessão ID',
    'Tipo de Cierre': 'Tipo de Fechamento',
    Sistema: 'Sistema',
    'Hora Fin': 'Fim do tempo',
    Geolocalización: 'Geolocalização',
    'Monto Apostado': 'Monto Apostado',
    'Créditos Promocionales Recibidos': 'Créditos Promocionais Recebidos',
    'Créditos Promocionales Apostados': 'Créditos Promocionales Apostados',
    'Motivo Cierre': 'Motivo do fechamento',
    'Saldo al Iniciar': 'Saldo ao Iniciar',
    'Saldo al Final': 'Saldo ao final',
    'Monto Ganado': 'Quantia auferida',
    'Sistema operativo': 'Sistema operacional',
    'Inicio de sesión fallidos': 'Logins falhados',
    'Cambio realizado a la cuenta': 'Alteração feita na conta',
    'Cuenta cancelada': 'Conta encerrada',
    'Arrastra Negativos': 'Arraste Negativos',
    Estadísticas: 'Estatísticas',
    Estadisticas: 'Estatísticas',
    Sí: 'Sim',
    'Añadir Agente:': 'Adicionar agente:',
    Eliminado: 'Eliminado',
    Devueltas: 'Retornado',
    'Añadir Código': 'Adicionar Código',
    'Editar Código': 'Editar Código',
    'Visitas Links': 'Visite Links',
    Registros: 'Registros',
    Edad: 'Idade',
    'Informe Red': 'Relatório da rede',
    'Realizar Transferencia': 'Fazer Transferência',
    Apellidos: 'Apelido',
    'Productos Terceros ': 'Produtos de terceiros',
    'La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.':
        'A senha deve conter pelo menos 8 caracteres, uma minúscula, uma maiúscula e um número.',
    Depositos: 'Depósitos',
    'JUGADORES ACTIVOS': 'JOGADORES ATIVOS',
    APUESTAS: 'APOSTAS',
    'PREMIOS PAGADOS': 'PRÊMIOS PAGOS',
    'Aprobación Logs': 'Aprovação Logs',
    'Aprobar log': 'Aprovar log',
    'Administración de Usuarios': 'Administração de usuários',
    'Administración de Usuarios Bloqueados': 'Administração de usuários Bloqueados',
    'Usuario:': 'Usuário:',
    'Usuario es de País': 'Usuário é do País',
    'Usuario es Global': 'Usuário é do Global',
    'Activar Usuario País': 'Ativar Usuário País',
    'Inactivar Usuario País': 'Desativar Usuario País',
    'Añadir Usuario:': 'Adicionar usuário:',
    'Perfil Opciones': 'Perfil Opções',
    'Códigos promocionales': 'Códigos promocionais',
    Función: 'Função',
    Registro: 'Registro',
    'Activar Registro': 'Ativar Registro',
    'Gestión Contacto': 'Contato Gerencial',
    'Fecha/Hora Creación': 'Data/Hora de criação',
    Nombres: 'Nomes',
    'Crear Nota': 'Criar Nota',
    Terminado: 'Concluído',
    'Flujo Caja': 'Fluxo de caixa',
    'Pago Nota de Retiro': 'Pagamento Nota de Saque',
    Máquinas: 'Máquinas',
    'Añadir Máquina': 'Añadir Máquina',
    'Añadir Máquina': 'Añadir Máquina',
    'Teléfono Mobile': 'Telefone celular',
    'Recargar Máquina ': 'Recarregar Máquina',
    'Actualizar Máquina': 'Atualização Máquina',
    'Actualizar Versión': 'Atualização Versão',
    'Actualizar Máquina': 'Atualização Máquina',
    Publicidad: 'Publicidade',
    'Fecha última entrada': 'Data da última entrada',
    'Estado de Máquina': 'Status da máquina',
    'Pago Nota de Cobro': 'Pagamento Nota de Saque',
    'Máquinas Grafica': 'Máquinas Gráficas',
    General: 'Geral',
    'Solicitud de retiro de clientes': 'Pedido de retirada do cliente',
    'Solicitud de depósito de clientes': 'Pedido de depósito do cliente',
    'Ajustes Generales': 'Configurações gerais',
    'Nombre Compañía': 'Nome da empresa',
    'Días de expiración de la contraseña': 'Dias de expiração da senha',
    'Regular Expresión contraseña usuario': 'Expressão regular da senha do usuário',
    'Días de expiración contraseña temporal': 'Dias de validade da senha temporária',
    'Mínima longitud de la contraseña': 'Comprimento mínimo da senha',
    'Días antes de notificación de expiración': 'Dias antes da notificação de expiração',
    'Expresión regular que valide una contraseña.': 'Expressão regular que valida uma senha.',
    'Ej: Que tenga entre 4 y 16 caracteres.': 'Ex: Entre 4 e 16 caracteres.',
    'Cuantos días antes de que expire la contraseña, se le notificara el cambio':
        'Quantos dias antes da expiração da senha, você será notificado da mudança.',
    'Máximo solicitudes por día': 'Máximo de pedidos por dia',
    'Porcentaje mínimo apostado/depositado': 'Percentual mínimo apostado/depositado',
    'Porcentaje mínimo apostado sobre lo depositado': 'Percentual mínimo apostado sobre o depósito',
    'Especifique el porcentaje mínimo apostado sobre lo depositado.':
        'Especificar a porcentagem mínima apostada sobre o valor depositado.',
    'Mínimo monto en solicitud de retiro': 'Valor mínimo de pedido de saque',
    'Máximo monto en solicitud de retiro': 'Valor máxima de pedido de saque',
    'Máxima cantidad de solicitudes activas': 'Valor máximo de pedidos ativas',
    'Mínimo monto de solicitud de deposito': 'Valor mínimo de pedido de depósito',
    'Máximo monto de solicitud de deposito': 'Valor máximo de pedido de depósito',
    'Impuesto Retiro Saldo Deposito': 'Imposto Saque Saldo do depósito',
    'Impuesto Retiro Saldo Premios a partir de': 'Imposto do Saque Prêmios de saldo a partir de',
    'Impuesto por Retiro Saldo Premios a partir de un valor.': 'Imposto sobre Saldo de saque Prêmios de um valor.',
    'Aprobar cuentas bancarias?': 'Aprovar contas bancárias?',
    'Porcentaje Penalidad Retiro Saldo Retiros': 'Porcentagem Penalidade Saque Saldo de Saques',
    'Especifique el porcentaje de la penalidad por retiro a saldo de retiros.':
        'Especifique a porcentagem da penalidade de saque para o saldo de saque.',
    'Días para alerta de actualización de datos': 'Dias para alerta de atualização de dados',
    'Días para alerta de actualización de datos del usuario.': 'Dias para alerta de atualização de dados do usuário.',
    'Impuesto Retiro Saldo Premios': 'Imposto Saque Saldo do Prêmios',
    'Impuesto al ente regulador a partir de': 'Imposto sobre o regulador a partir de',
    'Aprobar cambios de información personal?': 'Aprovar mudanças nas informações pessoais?',
    'Aprobar los cambios de información personal hechos por el usuario?':
        'Aprovar alterações nas informações pessoais feitas pelo usuário?',
    'Mínimo Retiro de Saldo Retiros para Penalizar': 'Saque de saldo mínimo Saques de penalidade',
    'Especifique el monto mínimo de retiro de saldo retiros para penalizar.':
        'Especificar o valor mínimo do saldo a ser penalizado.',
    'Días para alerta de cambio de contraseña': 'Dias de alerta de mudança de senha',
    'Impuesto al ente regulador': 'Imposto sobre o regulador',
    'Impuesto premios por punto de venta físico': 'Impostos Prêmios sobre as recompensas no ponto de venda',
    'Impuesto a los premios reclamados por punto de venta físico':
        'Imposto sobre prêmios reclamados pelo ponto de venda físico',
    'Máximo cuentas bancarias': 'Máximo de contas bancárias',
    'Porcentaje Penalidad Retiro Saldo Recargas': 'Porcentagem de penalidade Saque Saldo Recarga',
    'Especifique el porcentaje de la penalidad por retiro a saldo de recargas.':
        'Especifique a porcentagem da penalidade de retirada para o saldo de recarga.',
    'Porcentaje Invalido': 'Porcentagem inválida',
    'Inactividad de sesión en minutos': 'Inatividade da sessão em minutos',
    'Establezca el tiempo de inactividad en minutos para el cierre de sesión.':
        'Defina o tempo de inatividade em minutos para logout.',
    'Duración de la sesión en minutos': 'Duração da sessão em minutoss',
    'Establezca la duración de la sesión de juego en minutos.': 'Defina a duração da sessão de jogo em minutos.',
    'URL fondo casino': 'URL fundo do cassino',
    'Establezca la URL de la imagen para fondo de casino.': 'Definir a URL da imagem de fundo do cassino.',
    'Impuesto Retiro Saldo Deposito a partir de': 'Depósito de Saldo de Retirada de Impostos a partir de',
    'Impuesto por Retiro Saldo Deposito a partir de un valor': 'Saldo do Depósito de Imposto de Retirada de um Valor',
    'Requiere registro activo para iniciar sesión?': 'Você precisa de um registro ativo para fazer o login?',
    'Mínimo Retiro de Recargas para Penalizar': 'Saque Mínimo de Recarga para Penalizar',
    'Especifique el monto mínimo de retiro de saldo recargas para penalizar.':
        'Especificar o valor mínimo do saldo a ser penalizado.',
    'Liquidaciones generadas': 'Liquidações geradas',
    'Contigencia Total': 'Contigência Total',
    Automáticas: 'Automático',
    Manuales: 'Manuais',
    'Informacíon Actualizada': 'Informações atualizadas',
    'Días de expiración de la contraseña temporal': 'Dias de expiração da senha temporária',
    'Solicitudes de Depósitos': 'Pedidos de depósito',
    'Recepción de Efectivo': 'Recepção de Dinheiro',
    'Aprobar Depósito': 'Aprovar depósito',
    'Rechazar Depósito': 'Rejeitar depósito',
    'Método de pago cuentas bancarias': 'Forma de pagamento das contas bancárias',
    'Pagado físicamente': 'Fisicamente pago',
    'Pagado por sistema': 'Pagado por sistema',
    'Método de pago': 'Forma de pagamento',
    'Aprobar Nota': 'Aprovar Nota',
    'Desea Aprobar Nota de Retiro?': 'Deseja aprovar a Nota de Saque?',
    'Rechazar Nota': 'Nota de Rejeição',
    'Desea Rechazar Nota de Retiro?': 'Você deseja Rejeitar a Nota de Saque?',
    'Ver por un cajero en especifico': 'Vista para um caixa específico',
    Volver: 'Voltar',
    'Ingresos Tarjetas de crédito': 'Renda Cartões de crédito',
    'Otros Egresos': 'Outras despesas',
    'Añadir ingreso por tarjeta': 'Adicione pagamento com cartão',
    'Cerrar día': 'Dia de fechamento',
    'No hay datos': 'Sem dados',
    'Especifique si el usuario quedara automáticamente activado después del registro':
        'Especifique se o usuário será ativado automaticamente após o registro.',
    'Usuario automáticamente activado': 'Usuário ativado automaticamente',
    'Limite depósito día por defecto': 'Limite de depósito padrão',
    'Especifique el límite de depósito diario por defecto': 'Especificar o limite de depósito diário padrão',
    'Limite depósito semana por defecto': 'Limitar a semana de depósito por padrão',
    'Especifique el límite de depósito semanal por defecto': 'Especificar o limite de depósito semanal padrão',
    'Limite depósito mes por defecto': 'Limite de depósito mês padrão',
    'Especifique el límite de depósito mensual por defecto': 'Especificar o limite de depósito mensal padrão',
    'Limite depósito día global': 'Limite total do depósito diário',
    'Especifique el límite de depósito diario global': 'Especificar o limite global diário de depósito',
    'Limite depósito semana global': 'Limite depósito semana global',
    'Especifique el límite de depósito semanal global': 'Especificar o limite global de depósito semanal',
    'Limite depósito mes global': 'Limite de depósito global do mês',
    'Especifique el límite de depósito mensual global': 'Especifique o limite total do depósito mensal',
    'Máximo intentos inicio sesión': 'Máximo de tentativas de login',
    'Especifique el número máximo de intentos para iniciar sesión':
        'Especifique o número máximo de tentativas de log-in.',
    'Mínimo retiros punto': 'Mínimo saques ponto',
    'Mínimo monto en solicitud de retiro por punto de venta':
        'Montante mínimo de solicitação de saque por ponto de venda',
    Competidor: 'Concorrente',
    'Desea cancelar la cuenta del punto de venta?': 'Você quer cancelar a conta do Ponto de venda',
    'Fecha Pagado': 'Data de pagamento',
    'Tipo de cuenta': 'Tipo de conta',
    'Configuración Partner': 'Configuração Partner',
    'No tienes un QR Configurado, por favor comunicarse con soporte.':
        'Você não tem um QR Configurado, favor contatar o suporte.',
    30003: 'O usuário ou a senha está incorreta.',
    'Zona horaria:': 'Fuso horário:',
    'Moneda para reportes': 'Moeda para relatórios',
    'Impuesto sobre apuesta al pagar premio': 'Imposto de apostas no pagamento do prêmio',
    'Impuesto sobre el monto de la apuesta al momento de pagar el premio':
        'Imposto sobre o valor da aposta ao pagar o prêmio',
    'Verificó DNI posterior?': 'Você verificou a ID posterior??',
    'Verificó DNI anterior?': 'Você verificou a ID anterior??',
    'Tipo de liquidaciones comisiones': 'Tipo de comissões de assentamentos',
    'Especifique el tipo de liquidaciones para las comisiones, sea por caja o por cierre.':
        'Especificar o tipo de liquidação das comissões, seja à vista ou de fechamento.',
    Cierre: 'Encerramento',
    'Cierre Pagada': 'Fechamento pago',
    'El usuario o la clave son incorrectos. (Report#30003)': 'O nome de usuário ou senha está incorreto.(Report#30003)',
    'Premio Total': 'Prêmio total',
    'Total Caja:': 'Dinheiro total:',
    'Se cerró el día satisfactoriamente': 'O dia foi encerrado com sucesso',
    'Ya se efectuó el cierre de día, nos es posible realizar esta operación':
        'O encerramento do dia já aconteceu, não nos é possível realizar esta operação.',
    'Ticket Ganador': 'Ticket Vencedor',
    'Ticket Perdedor': 'Ticket Perdedor',
    'Ticket Pendiente': 'Ticket Pendente',
    'Ticket no encontrado': 'Ticket não encontrado',
    'Nota de retiro no encontrada': 'Nota de saque não encontrada',
    'Nota de retiro pagada': 'Nota de saque paga',
    'Confirmar Valor:': 'Confirmar valor:',
    'Confirmar Valor': 'Confirmar valor:',
    'Valores no coinciden': 'Os valores não correspondem',
    'Ya se efectuó el cierre de día, no es posible realizar esta operación':
        'O encerramento do dia já ocorreu, não é possível realizar esta operação.',
    'Apuestas Deportivas': 'Apostas esportivas',
    'Apuestas deportivas en vivo': 'Apostas esportivas ao vivo',
    'Apuestas Virtuales': 'Apostas virtuais',
    'El usuario no se encuentra o ya fue activado': 'O usuário não é encontrado ou já foi ativado',
    'Premio pagado satisfactoriamente': 'Prêmio pago com sucesso',
    'ID Afiliador': 'ID Afiliador',
    'Nombre Afiliador': 'Nome Afiliador',
    'Recargas Eliminadas': 'Recarregas Eliminadas',
    'Cupo Recarga E': 'Cota de recarga E',
    'Cupo Recarga S': 'Cota de recarga S',
    'Cupo recargas inicial': 'Cota inicial de recarga',
    'Cupo juego inicial': 'Cota jogo de abertura',
    'Cupo recargas final': 'Cota recargas finais',
    'Cupo recargas final Calc.': 'Cota de recarga final Calc',
    'Cupo juego final': 'Cota jogo final',
    'Cupo juego final Calc.': 'Cota jogo final Calc',
    'Historial de saldo punto de venta': 'Histórico do saldo do ponto de venda',
    'Cupo Apuesta E': 'Cota Aposta E',
    'Cupo Apuesta S': 'Cota Aposta S',
    'Punto de venta propio?': 'Ponto de venda próprio?',
    'Tipos de documentos': 'Tipos de documentos',
    'Tipo de documento agregado': 'Tipo de documento adicionado',
    'Tipo de documento actualizado': 'Tipo de documento atualizado',
    'Añadir tipo de documento': 'Adicionar tipo de documento',
    'Editar tipo de documento': 'Editar tipo de documento',
    'Serie:': 'Série:',
    'Tipo documento:': 'Tipo Documento:',
    'Impuesto:': 'Imposto:',
    'Saldo Antes de Ajuste': 'Saldo antes do ajuste',
    'Saldo Despues de Ajuste': 'Saldo após ajuste',
    'Numero Autoexclusiónes': 'Número de auto-exclusões',
    'Motivo Autoexclusión': 'Motivo da auto-exclusão',
    'Fondos Depositados': 'Fundos depositados',
    'Fondos Retirados': 'Fundos Retirados',
    'Fondos Restantes de Juegos Incompletos': 'Fundos remanescentes dos Jogos Incompletos',
    'Requiere registro activo para depositar?': 'Requer registro ativo para depositar?',
    'Especifique si el usuario necesita tener el registro activado para poder depositar':
        'Especificar se o usuário precisa ter o registro ativado para poder depositar',
    'Requiere verificación de cuenta para depositar?': 'Verificação de conta requerida para depósito?',
    'Especifique si el usuario necesita verificar cuenta para poder depositar':
        'Especificar se o usuário precisa verificar a conta para poder depositar',
    'Requiere registro activo para retirar?': 'Exige registro ativo para retirar?',
    'Especifique si el usuario necesita tener el registro activado para poder retirar':
        'Especificar se o usuário precisa ter o registro ativado para poder se retirar',
    'Requiere verificación de cuenta para retirar?': 'Verificação de conta necessária para retirada?',
    'Especifique si el usuario necesita verificar cuenta para poder retirar':
        'Especificar se o usuário precisa verificar a conta para poder retirar',
    'Tipo de comisión puntos de venta': 'Tipo de comissão das lojas',
    'Especifique el tipo de comisión para los puntos de venta.': 'Especificar o tipo de comissão para as lojas.',
    'Logs Usuario General': 'Logs gerais do usuário',
    'Especifique el tipo de comisión para los puntos de venta.': 'Especificar o tipo de comissão para as lojas.',
    Explicación: 'Explicação',
    'Reporte General Logs': 'Relatórios gerais de Logs ',
    Elemento: 'Elemento',
    'Valor antes': 'Valor antes',
    'Valor despues': 'Valor após',
    'Usuarios Depositantes': 'Usuários depositantes',
    'Cantidad Depositos': 'Quantidade de depósitos',
    'Ordenar por': 'Ordenar por',
    Orden: 'Ordem',
    Ascendente: 'Ascendente',
    Descendente: 'Descendente',
    Cajero: 'Caixa',
    'Historico Saldos Punto Venta': 'Histórico do Balanço das lojas',
    'Reporte Comisiones Global': 'Relatório das Comissões Globais',
    'Desea cerrar día?': 'Você deseja fechar o dia?',
    Impuestos: 'Impostos',
    'Fecha de exportación: ': 'Data de exportação:',
    'Confirme recarga de ': 'Confirmar recarga de',
    ' para el usuario ': 'para o usuário',
    'Tipo de Saldo': 'Tipo de Saldo',
    'Saldo de Recargas': 'Saldo de Recarga',
    Continuar: 'Continuar',
    'Reporte de Transferencias': 'Relatório de transferências',
    'Usuario Creó': 'Criado pelo usuário',
    'Usuario Recibió': 'Recebido Pelo Usuário',
    'Fecha de reporte: Desde ': 'Data do relatório: De',
    ' Hasta ': ' Ate ',
    'Desea Rechazar la Retracción de Saldo?': 'Você quer Recusar a Retirada de Saldo?',
    'Estado de Retracción actualizado': 'Status de retratação atualizado',
    'Desea Aprobar el Retracción de Saldo?': 'Você gostaria de aprovar a retirada de saldo?',
    'Aprobación de Retracción de Saldo': 'Aprovação de Retirada de Saldo',
    'Te estas logueando desde el sitio equivocado.': 'Você está entrando no site errado.',
    '¡Serás redireccionado a tu sitio!': '¡Você será redirecionado para seu site!',
    '¡Atención!': '¡Atenção!',
    'IR AL SITIO': 'IR PARA A PÁGINA',
    'Punto Venta Pagó': 'Loja que pago',
    '¿Es de movimiento de base de caja?': 'É um movimento baseado em caixas?',
    'Centro de costo personalizado': 'Centro de custo personalizado',
    'Apuestas Anuladas': 'Apostas canceladas',
    'Apuestas Pagadas Anuladas': 'Apostas pagas anuladas',
    'Estado Celular': 'Estado Celular',
    'Sin verificar': 'Não verificado',
    'Descripción del reporte: Flujo Caja Resumido': 'Descrição do relatório: Resumo do fluxo de caixa',
    'Fecha creación del reporte: ': 'Data de criação do relatório: ',
    'Flujo Caja Resumido': 'Resumo do fluxo de caixa',
    'Sub Diario': 'Sub Diario',
    'Número de Comprobante': 'Número de Comprobante',
    'Fecha de Comprobante': 'Fecha de Comprobante',
    'Código de Moneda': 'Código de Moneda',
    'Glosa Principal': 'Glosa Principal',
    'Tipo de Cambio': 'Tipo de Cambio',
    'Tipo de Conversión': 'Tipo de Conversión',
    'Flag de Conversión de Moneda': 'Flag de Conversión de Moneda',
    'Fecha Tipo de Cambio': 'Fecha Tipo de Cambio',
    'Cuenta Contable': 'Cuenta Contable',
    'Código de Anexo': 'Código de Anexo',
    'Código de Centro de Costo': 'Código de Centro de Costo',
    'Debe / Haber': 'Debe / Haber',
    'Importe Original': 'Importe Original',
    'Importe en Dólares': 'Importe en Dólares',
    'Importe en Soles': 'Importe en Soles',
    'Tipo de Documento': 'Tipo de Documento',
    'Número de Documento': 'Número de Documento',
    'Fecha de Documento': 'Fecha de Documento',
    'Fecha de Vencimiento': 'Fecha de Vencimiento',
    'Código de Area': 'Código de Area',
    'Glosa Detalle': 'Glosa Detalle',
    'Código de Anexo Auxiliar': 'Código de Anexo Auxiliar',
    'Medio de Pago': 'Medio de Pago',
    'Tipo de Documento de Referencia': 'Tipo de Documento de Referencia',
    'Número de Documento Referencia': 'Número de Documento Referencia',
    'Fecha Documento Referencia': 'Fecha Documento Referencia',
    'Nro Máq. Registradora Tipo Doc. Ref.': 'Nro Máq. Registradora Tipo Doc. Ref.',
    'Base Imponible Documento Referencia': 'Base Imponible Documento Referencia',
    'IGV Documento Provisión': 'IGV Documento Provisión',
    'Tipo Referencia en estado MQ': 'Tipo Referência de status  MQ',
    'Número Serie Caja Registradora': 'Número de série Caixa',
    'Fecha de Operación': 'Data de operação',
    'Tipo de Tasa': 'Tipo de taxa',
    'Tasa Detracción/Percepción': 'Tasa Detracción/Percepción',
    'Importe Base Detracción/Percepción Dólares': 'Importe Base Detracción/Percepción Dólares',
    'Importe Base Detracción/Percepción Soles': 'Importe Base Detracción/Percepción Soles',
    'Tipo Cambio para F': 'Tipo Cambio para F',
    'Importe de IGV sin derecho crédito fiscal': 'Importe de IGV sin derecho crédito fiscal',
    'Ver T.G. 02': 'Ver T.G. 02',
    'Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo':
        'Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo',
    'Ver T.G. 03': 'Ver T.G. 03',
    "Llenar solo si Tipo de Conversión es 'C'. Debe estar entre >=0 y <=9999.999999":
        "Llenar solo si Tipo de Conversión es 'C'. Debe estar entre >=0 y <=9999.999999",
    "Solo: 'C'= Especial, 'M'=Compra, 'V'=Venta , 'F' De acuerdo a fecha":
        "Solo: 'C'= Especial, 'M'=Compra, 'V'=Venta , 'F' De acuerdo a fecha",
    "Solo: 'S' = Si se convierte, 'N'= No se convierte": "Solo: 'S' = Si se convierte, 'N'= No se convierte",
    "Si Tipo de Conversión 'F'": "Si Tipo de Conversión 'F'",
    'Debe existir en el Plan de Cuentas': 'Debe existir en el Plan de Cuentas',
    'Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos':
        'Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos',
    'Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05':
        'Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05',
    "'D' ó 'H'": "'D' ó 'H'",
    'Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99 ':
        'Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99 ',
    "Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estar entre >=0 y <=99999999999.99 ":
        "Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estar entre >=0 y <=99999999999.99 ",
    "Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estra entre >=0 y <=99999999999.99 ":
        "Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estra entre >=0 y <=99999999999.99 ",
    'Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06':
        'Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06',
    'Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número':
        'Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número',
    'Si Cuenta Contable tiene habilitado el Documento Referencia':
        'Si Cuenta Contable tiene habilitado el Documento Referencia',
    'Si Cuenta Contable tiene habilitada la Fecha de Vencimiento':
        'Si Cuenta Contable tiene habilitada la Fecha de Vencimiento',
    'Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26':
        'Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26',
    'Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia':
        'Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia',
    "Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. 'S1'":
        "Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. 'S1'",
    "Si Tipo de Documento es 'NA' ó 'ND' Ver T.G. 06": "Si Tipo de Documento es 'NA' ó 'ND' Ver T.G. 06",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND', incluye Serie y Número":
        "Si Tipo de Documento es 'NC', 'NA' ó 'ND', incluye Serie y Número",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'": "Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'. Solo cuando el Tipo Documento de Referencia 'TK'":
        "Si Tipo de Documento es 'NC', 'NA' ó 'ND'. Solo cuando el Tipo Documento de Referencia 'TK'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'": "Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'": "Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y Tipo de Documento es 'TK'":
        "Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y Tipo de Documento es 'TK'",
    "Si la Cuenta Contable teien Habilitado Documento Referencia 2 y Tipo de Documento es 'TK'":
        "Si la Cuenta Contable teien Habilitado Documento Referencia 2 y Tipo de Documento es 'TK'",
    "Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es 'TK', consignar la fecha de emision del ticket":
        "Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es 'TK', consignar la fecha de emision del ticket",
    "Si la Cuenta Contable tiene configurada la Tasa: Si es '1' ver T.G. 28 y '2' ver T.G. 29":
        "Si la Cuenta Contable tiene configurada la Tasa: Si es '1' ver T.G. 28 y '2' ver T.G. 29",
    "Si la Cuenta Contable tiene conf. en Tasa: Si es '1' ver T.G. 28 y '2' ver T.G. 29. Debe estar entre >=0 y <=999.99":
        "Si la Cuenta Contable tiene conf. en Tasa: Si es '1' ver T.G. 28 y '2' ver T.G. 29. Debe estar entre >=0 y <=999.99",
    'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99':
        'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99',
    'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99':
        'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99',
    "Especificar solo si Tipo Conversión es 'F'. Se permite 'M' Compra y 'V' Venta.":
        "Especificar solo si Tipo Conversión es 'F'. Se permite 'M' Compra y 'V' Venta.",
    'Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx':
        'Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx',
    'Exportación Masiva': 'Exportação em massa',
    'Cuenta de cancelación': 'Conta de cancelamento',
    'Estado de Contingencia Retiro': 'Estado de contingência de saque',
    'Estado de Contingencia Deposito': 'Estado de contingência ao Depósito',
    'Estado Especial': 'Status especial',
    'Proveedor de SMS': 'Fornecedor de SMS',
    'Proveedor de Email': 'Fornecedor de e-mail',
    'Cerrar día especifico': 'Fechar dia específico',
    'Descripción del reporte: Flujo Caja Resumido ': 'Descrição do relatório: Resumo do fluxo de caixa ',
    ' Fecha creación del reporte: ': ' Data de criação do relatório: ',
    Serie: 'Série',
    'QR Copiado!': 'QR Copiado!',
    'Enviar código al celular': 'Enviar código ao telefone celular',
    'Código enviado': 'Código enviado',
    '¿Producto tiene cupo?': '¿Produto tem cota?',
    'Productos terceros con cupo': 'Produtos de terceiros com cota',
    'Agregar cupo': 'Quota agregada',
    'Cupo Agregado': 'Quota agregada',
    'Ingreso editado satisfactoriamente': 'Entrada editada com sucesso',
    'Editar Ingreso': 'Editar Entrada',
    'Editar Egreso': 'Editar Saida',
    'Egreso editado satisfactoriamente': 'Saída editada com sucesso',
    'Ingreso por tarjeta de crédito editado satisfactoriamente': 'Entrada do cartão de crédito editado com sucesso',
    Identificador: 'Identificador',
    Todas: 'Todas',
    Expiradas: 'Expirado',
    'Proveedor pagos de retiros': 'Fornecedor de Pagamento',
    'Añadir Ingreso Producto Cupo': 'Add Product Income Quota',
    'Producto:': 'Produto:',
    'Cuenta Contable Cierre': 'Fechamento da conta contábil',
    '¿Somos agentes?': 'Somos agentes?',
    'Máximo monto por retiro': 'Valor máximo por retirada',
    'Máximo monto pago premio': 'Valor máximo de pagamento do prêmio',
    'Por fecha de retiro pagado': 'Por data de retirada paga',
    'Banner Invasivo': 'banner invasivo',
    Popup: 'Popup',
    Franja: 'faixa',
    'Fecha Caducidad Pago': 'Data de Vencimento Pagamento',
    'Enviar banner invasivo': 'Enviar banner invasivo',
    'Enviar popup': 'Enviar popup',
    'Enviar franja': 'Enviar faixa',
    'URL Imagen': 'Imagem URL',
    'URL Redirección': 'Redirecionamento de URL',
    Contenido: 'Conteúdo',
    'Texto del botón': 'Texto dos botões',
    'Usuarios Id': 'Usuários Id',
    'Fecha envío': 'Data de envio',
    'Fecha expiración': 'Data de expiração',
    '¿Es un juego?': 'É um jogo?',
    'Ir al usuario': 'Ir para o usuário',
    'Categorías sin agregar': 'Categorias não adicionadas',
    'Categorías Producto Partner': 'Categorias Parceiro de produto',
    'Seleccione por lo menos un Partner': 'Selecione pelo menos um Parceiro',
    'Partners Seleccionados': 'Parceiros selecionados',
    'Partners no Seleccionados': 'Parceiros não selecionados',
    'Sub Proveedor': 'Sub fornecedor',
    'Franja Superior': 'Faixa superior',
    'Desea Eliminar Egreso?': 'Você quer excluir as saídas?',
    'Eliminar Egreso': 'Saída Eliminada',
    'Egreso Eliminado': 'Saída Eliminada',
    'Desea Eliminar Ingreso?': 'Excluir Entrada?',
    'Eliminar Ingreso': 'Entrada Excluida',
    'Ingreso Eliminado': 'Entrada Excluida',
    'Apuestas Canceladas': 'Apostas canceladas',
    'Partner Referencia': 'Referência de parceiros',
    'Tipo de registro': 'Tipo de Cadastro',
    'Especifique tipo de registro si es corto o largo': 'Especifique o tipo de cadastro se ele é curto ou longo',
    Corto: 'Curta',
    Largo: 'Longo',
    'No Expiradas': 'Não expirado',
    Plantillas: 'Modelo',
    'Plantilla email guardada': 'Modelo de Email guardado',
    'Plantilla sms guardada': 'Modelo de SMS guardado',
    Ninguno: 'Nenhum',
    'Pagado fisicamente': 'Fisicamente pago',
    'Rechazar nota de retiro': 'Rejeitar nota de retirada',
    'Elija la forma de pago': 'Escolha a forma de pagamento',
    'Pagar Nota': 'Pagar Nota',
    'Desea Pagar Nota de Retiro?': 'Você quer pagar uma Nota de Retirada??',
    'Nota de Retiro Rechazada': 'Nota de Retirada Rejeitada',
    'Nota de Retiro Aprobado': 'Nota de Retirada Aprovada',
    'Reporte de billeteras': 'Relatório de carteira',
    'Desea Activar Billetera?': 'Você quer ativar a carteira?',
    'Activar Billetera': 'Carteira ativada',
    'Billetera Activada': 'Carteira ativada',
    'Desea Inactivar Billetera?': 'Você quer desativar a carteira?',
    'Inactivar Billetera': 'Carteira inativada',
    'Billetera Inactivada': 'Carteira inativada',
    Resumido: 'Resumido',
    'Configuración SEO': 'Configuração SEO',
    'Leido?': 'Leia?',
    'Información Extra': 'Informações adicionais',
    'Reporte de transacciones del saldo': 'Relatório de transações de saldo',
    'Desea aprobar notas de retiro seleccionadas?': 'Você quer aprovar as notas de retirada selecionadas?',
    'Aprobar Notas': 'Aprovar Notas',
    'Notas de retiro aprobadas': 'Notas de retirada aprovadas',
    'Seleccione por lo menos una nota de retiro para aprobar': 'Selecione pelo menos uma nota de retirada para aprovar',
    '¿Es nuevo?': 'É novo?',
    '¿Esta seguro de realizar cambios en la configuración del SEO?':
        'Are you sure about making changes to your SEO settings?',
    'Añadir SEO': 'Adicionar SEO',
    Idioma: 'Idioma',
    'PÁGINA:': 'PÁGINA:',
    'Historial de transferencias de saldo': 'Histórico de transferência de saldos',
    'Confirme retracción de ': 'Confirmar a retração de ',
    Retraer: 'Retraer',
    'Transferir a Usuario': 'Transferir ao Usuário',
    'Retracción a Usuario': 'Retração do usuário',
    'Valor Invalido': 'Valor inválido',
    'Activa o inactiva el tipo de saldo recargas': 'Ativar ou desativar o tipo de recarga de saldo',
    'Activa o inactiva el tipo de saldo retiros': 'Ativar ou desativar o tipo de retirada de saldo',
    'Saldo bonos': 'Saldo bonos',
    'Activa o inactiva el tipo de saldo bonos': 'Ativa ou inativa o tipo de saldo Bonus',
    'Saldo freebet': 'Saldo freebet',
    'Activa o inactiva el tipo de saldo freebet': 'Ativa ou inativa o tipo de saldo freebet',
    'Saldo freecasino': 'Saldo freecasino',
    'Activa o inactiva el tipo de saldo freecasino': 'Ativa ou inativa o tipo de saldo freecasino',
    'Retracción a Saldo Juego': 'Retirada para saldo do jogo',
    'Retracción a Saldo Recargas': 'Retirada para saldo recargas',
    Sección: 'Seção',
    'Id de transacción relacionada': 'Identificação da transação relacionada',
    'Historial de transferencias de saldo realizadas': 'Histórico de transferências de saldos feitas',
    'Historial de transferencias de saldo recibidas': 'Histórico de transferências de saldos recebidos',
    'Transferir Saldo a ': 'Transferir saldo para',
    'Historial de saldo agentes': 'Histórico de saldo de agentes',
    'Historial de saldo usuario administrativo': 'Histórico de balanço usuário administrativo',
    'Bonos casino': 'Bonus Cassino',
    'Bonos Virtuales': 'Bonus Virtuais',
    'Bonos Casino en vivo': 'Bonus Cassino Ao Vivo',
    'Fecha Cambio': 'Data de modificação',
    'Fecha Acción': 'Data de Ação',
    'Fecha Cierre': 'Data de fechamento',
    'Usuario Pagó': 'Usuário pagante',
    'Impuesto Apuesta': 'Imposto de Apostas',
    'Impuesto Apuestas': 'Imposto de Apostas',
    'Impuesto Premios': 'Imposto de Prêmio',
    'Impuesto Premio': ' Imposto de Prêmio',
    'Con pasarelas de pago?': 'With payment gateways?',
    'Su sesión se ha perdido, acceda nuevamente.': 'Sua sessão foi perdida, faça o login novamente.',
    Aceptar: 'Aceitar',
    'Con apuestas anuladas?': 'Com apostas canceladas?',
    'Con premios pendientes?': 'Com prêmios pendentes?',
    'Esta nota de retiro no tiene permitido el pago por sistema':
        'Esta nota de retirada não é permitida para pagar por sistema',
    'Agregar Archivo': 'Adicionar arquivo',
    'Se ha realizado la Actualización satisfactoriamente.': 'A atualização foi um sucesso.',
    'Historial de saldo máquinas': 'Histórico de saldo da máquina',
    'Flujo Caja Resumido Máquina': 'Resumo do fluxo de caixa da máquina',
    'Máquina Productos': 'Produtos Máquina',
    'Máquina Proveedores': 'Máquina do fornecedor',
    'Máquina Sub Proveedores': 'Subfornecedor Máquina',
    'Máquina Tipo': 'Tipo de máquina',
    'Máquina Referencia': 'Máquina de referência',
    'Categoría Máquina Editado': 'Categoria da máquina editada',
    'Producto Máquina Editado': 'Produtos de máquinas editadas',
    'Proveedor Máquina Editado': 'Fornecedor de máquinas editadas',
    'Sub Proveedor Máquina Editado': 'Subfornecedor de máquinas editadas',
    'Tipo producto Máquina Editado': 'Tipo de máquina editada',
    'Agrupado sólo por usuario afiliador': 'Agrupado somente por usuário afiliado',
    'Id Sistema': 'Id Sistema ',
    'Ver sólo por punto de venta': 'Veja somente por Loja',
    'Proveedores internos': 'Fornecedores internos',
    'Programa de lealtad': 'Programa de lealdade',
    'Puntos requeridos para el nivel 1': 'Points required for level 1',
    'Puntos requeridos para el nivel 2': 'Points required for level 2',
    'Puntos requeridos para el nivel 3': 'Points required for level 3',
    'Puntos requeridos para el nivel 4': 'Points required for level 4',
    'Puntos requeridos para el nivel 5': 'Points required for level 5',
    'Puntos requeridos para el nivel 6': 'Points required for level 6',
    'Puntos requeridos para el nivel 7': 'Points required for level 7',
    'Puntos requeridos para el nivel 8': 'Points required for level 8',
    'Puntos requeridos para el nivel 9': 'Points required for level 9',
    'Puntos requeridos para el nivel 10': 'Points required for level 10',
    'Monto depósito': 'Deposit amount',
    'Monto (Dinero) requerido de los depósitos para obtener Z punto':
        'Amount (Money) required from deposits to get Z point',
    'Deportiva simple': 'Simple sporty',
    'Monto (Dinero) requerido de una apuesta deportiva simple para obtener Z punto':
        'Amount (Money) required of a simple sports bet to get Z point',
    'Deportiva combinada de 2': 'Sports combined 2',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 2 para obtener Z punto':
        'Amount (Money) required from a Combination of 2 sports bet to earn Z point',
    'Deportiva combinada de 3': 'Sports combined 3',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 3 para obtener Z punto':
        'Amount (Money) required of a Combination of 3 sports bet to get Z point',
    'Deportiva combinada de 4': 'Sports combined 4',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 4 para obtener Z punto':
        'Amount (Money) required of a Combination of 4 sports bet to earn Z point',
    'Deportiva combinada de 5': 'Sports combined 5',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 5 para obtener Z punto':
        'Amount (Money) required from a Combination of 5 sports bet to earn Z point',
    'Deportiva combinada de 6': 'Sports combined 6',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 6 para obtener Z punto':
        'Amount (Money) required of a 6 pound sports bet to earn Z point',
    'Deportiva combinada de 7': 'Sports combined 7',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 7 para obtener Z punto':
        'Amount (Money) required from a Combination 7 sports bet to earn Z point',
    'Deportiva combinada de 8': 'Sports combined 8',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 8 para obtener Z punto':
        'Amount (Money) required of a Combined 8 sports bet to earn Z point',
    'Deportiva combinada de 9': 'Sports combined 9',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 9 para obtener Z punto':
        'Amount (Money) required of a Combined 9 sports bet to earn Z point',
    'Deportiva combinada de 10': 'Sports combined 10',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 10 para obtener Z punto':
        'Amount (Money) required of a Combination of 10 sports bet to earn Z point',
    'Premios deportivos': 'Prêmios de Esportes',
    'Monto (Dinero) requerido de premios deportivos para obtener Z punto':
        'Amount (Money) required of sports awards to obtain Z point',
    'Apuestas en Casino:': 'Apostas en cassino:',
    'Monto (Dinero) requerido de apuestas de casino para obtener Z punto':
        'Amount (Money) required of casino bets to get Z point',
    'Premios de casino': 'Prêmios do cassino',
    'Monto (Dinero) requerido de premios de casino para obtener Z punto':
        'Amount (Money) required of casino prizes to get Z point',
    'Monto requerido de retiros': 'Quantidade necessária de saques',
    'Monto (Dinero) requerido de retiros para obtener Z punto':
        'Amount (Money) required of withdrawals to obtain Z point',
    'Puntos Base': 'Pontos Básicos',
    'Especifique el numero de puntos que se tomara como base, equivalente a Z en los demás items.':
        'Specify the number of points to be taken as a base, equivalent to Z in the other items.',
    'Tipos de movimientos': 'Tipos de movimentos',
    'Puntos equivalentes por nivel': 'Pontos equivalentes por nível',
    'IP de Cambio': 'CambioIp',
    'Ip Acción': 'Ação Ip',
    'Puntos Lealtad': 'Pontos de Fidelidade',
    Observaciones: 'Observações',
    'Impuesto del GGR de la apuesta al momento de pagar': 'GGR tax of the bet at checkout',
    'Días de expiración de puntos': 'Dias de expiração dos pontos',
    'Especifique el tiempo en días para la caducidad de los puntos':
        'Especificar o tempo em dias para a expiração dos pontos',
    'Depositos:': 'Depositos:',
    'Apuestas en Deportivas:': 'Apostas en esportes:',
    'Apuestas en Casino:': 'Apostas en cassino:',
    'Total Apuestas:': 'Total Apostas:',
    'Premios deportivos': 'Prêmios de Esportes',
    'Premios de casino': 'Prêmios do cassino',
    'Total Premios:': 'Total Prêmios:',
    'Notas pendientes:': 'Notas Pendentes:',
    'Valor Retirado:': 'Valor Retirado:',
    'Bonos:': 'Bônus:',
    'Bonos Free Ganados:': 'Bônus Grátis Ganhados:',
    'Ajustes Entrada:': 'Configurações de entrada:',
    'Ajustes Salida:': 'Configurações de saída:',
    'Total:': 'Total:',
    'Desea realizar movimiento?': 'Você quer fazer movimento?',
    'Reporte de Sesiones Casino': 'Relatório das Sessões do Cassino',
    'Máximo monto retiro por punto de venta': 'Montante máximo de retirada por loja',
    'Especifique el monto máximo para retirar por punto de venta':
        'Especificar o valor máximo a ser retirado por em loja',
    'Saldo al Final': 'Saldo Final',
    'Valor de depósitos': 'Valor do deposito',
    'Apuestas deportivas': 'Apostas de Esportes',
    'Premios deportivos': 'Prêmios de Esportes',
    'Cancelaciones deportivas': 'Cancelamentos esportes',
    'Apuestas de casino': 'Apostas do Cassino',
    'Premios de casino': 'Prêmios do cassino',
    'Cancelaciones de casino': 'Cancelamentos de cassinos',
    'Retiros realizados': 'Retiradas feitas',
    'Retiros cancelados': 'Retiradas Canceladas',
    'Bonos redimidos': 'Bônus resgatados',
    Encriptación: 'Criptografia',
    'Desea imprimir recibo?': 'Você quer imprimir um recibo?',
    Imprimir: 'Imprimir',
    'Verificó domicilio': 'Endereço verificado',
    'Link Afiliados:': 'Link Afiliados:',
    'QR Afiliados:': 'QR Afiliados:',
    'Saldo:': 'Saldo:',
    Billetera: 'Carteira',
    Comisión: 'Comissão',
    'Transferencias recibidas': 'Transferências recebidas',
    'Transferencias realizadas': 'Transferências feitas',
    'Reporte de retiros': 'Relatório de Retirada',
    'Reporte de Depósitos Punto de venta': 'Relatório de Deposito da Loja',
    'Reporte de Retiros Punto de Venta': 'Relatório de Retirada da Loja',
    'Fecha de pago': 'Data de pagamento',
    'Reporte de transferencias de saldo Recibidas': 'Relatório de Transferências de Saldos Recebidos',
    'Reporte de transferencias de saldo Realizadas': 'Relatório de transferências de saldo feitas',
    'Tipo de Billetera': 'Tipo de Carteira',
    'Reporte de Afiliados': 'Relatório de Afiliados',
    'Recepcion de Efectivo': 'Recebimento em dinheiro',
    'ID Billetera': 'ID Carteira',
    'Reporte de Billeteras': 'Relatório de carteira',
    'Desea Inactivar Billetera?': 'Você quer desativar a carteira?',
    'Billetera Inactivada': 'Carteira inativada',
    Billeteras: 'Carteiras',
    Cupones: 'Cupões',
    'Desea enviar el cupón?': 'Você quer enviar o cupom?',
    'Cupón Enviado Satisfactoriamente': 'Cupom enviado com sucesso',
    'Cantidad:': 'Quantidade:',
    'Transf Apuesta E': 'Bet Transf E',
    'Transf Apuesta S': 'Bet Transf S',
    'Transf Recarga E': 'Top-up Transf E',
    'Transf Recarga S': 'Top-up Transf S',
    'Calc. Desfase': 'Cálculo de Desfase',
    Cupo: 'Quota',
    'Cupo Calc.': 'Cálculo de quota',
    'Complete Datos': 'Complete os Dados',
    'Cajero:': 'Caixa:',
    'Reporte de casino ': 'Relatório do cassino',
    'Historico Saldos Agentes': 'Saldos históricos Agentes',
    'Historico Saldos Administrativos': 'Saldos administrativos históricos',
    'Transferencias de saldo': 'Transferências de saldos',
    'Retracción de saldo': 'Retração do saldo',
    'ID Final': 'ID Final',
    'ID Retiro': 'ID de Retirada',
    Enviada: 'enviado',
    'Fecha de Eliminación': 'Data da Eliminação',
    'Consolidado nivel': 'Valor consolidado',
    'No tiene permitido el pago por sistema': 'O pagamento por sistema não é permitido',
    'Editar Proveedor': 'Editar Fornecedor',
    SubProveedor: 'Sub fornecedor',
    Observación: 'Observação',
    'Ajuste de Saldo': 'Ajuste do saldo',
    'Apuestas Casino': 'Apostas Cassino',
    'Nota de retiro Creada': 'Nota de saque criada',
    'Nota de retiro Pagada': 'Nota de saque paga',
    'Bono Redimido': 'Bônus Redimido',
    'Aumento de cupo': 'Quota increase',
    'Cuenta deshabilitada': 'Conta desativada',
    'Cambio de contraseña': 'Mudança de senha',
    'Valores no permitiros...': 'Valores não permitidos ....',
    Códigos: 'Códigos',
    DNI: 'CPF',
    'Pendiente por Sistema': 'Pendente pelo sistema',
    'Aprobado por Sistema': 'Aprovado pelo sistema',
    'Rechazado por Sistema': 'Rejeitado pelo sistema',
    'ID Concesionario': 'ID Agente',
    'Parte Superior Impresión recibo de pago de premio': 'Topo da impressão Recibo de pagamento do prêmio',
    'Parte Inferior Impresión recibo de pago de premio': 'Fundo Impressão do recibo de pagamento do prêmio',
    'Parte Superior Impresión recibo de pago de retiro': 'Topo da impressão do recibo de pagamento de saque',
    'Parte Inferior Impresión recibo de pago de retiro': 'Fundo Imprimir recibo de pagamento de retirada',
    'Impuesto al pago de premio (GGR)': 'Imposto sobre o pagamento de prêmios (GGR)',
    'Es Propio?': 'É próprio?',
    'Tipo de Punto': 'Tipo de ponto',
    Físico: 'físico',
    '(Nota: Por cada monto en XXX va a obtener Z puntos base)':
        '(Nota: Para cada valor em XXX você receberá pontos base Z)',
    'Número de teléfono:': 'Número de telefone:',
    'Tipo de establecimiento': 'Tipo de instalação',
    'Sportbook NGR Afiliados': 'Sportbook NGR Afiliados',
    'Sportbook GGR Punto venta IP': 'Sportbook GGR Loja IP',
    'Sportbook GGR Punto venta': 'Sportbook GGR Loja',
    'Deposito Punto venta': 'Deposito em Loja',
    'Nro. de Agente:': 'Número do Agente:',
    'Nombre del agente:': 'Nome do Agente:',
    'Recargar Credito Agente': 'Carregar credito ao Agente',
    'Solo Saldos Negativos': 'Somente Saldos Negativos',
    'Contingencia Total': 'Contingência Total',
    'Contingencia Deportivas': 'Contingência Esportivas',
    'Contingencia Casino': 'Contingência Cassino',
    'Contingencia Casino en Vivo': 'Contingência Cassino ao vivo',
    'Contingencia Virtuales': 'Contingência Virtuais',
    'Contingencia Poker': 'Contingência Poker',
    'Contingencia Retiro': 'Contingência Retirada ',
    'Contingencia Depósito': 'Contingência deposito',
    'Contingencia masiva': 'Contingência massiva',
    'Cargar archivo CSV': 'Carregar Arquivos CSV',
    'Contingencia masiva creada': 'Contingência massiva criada',
    'V. Entradas Recargas Agentes': 'V. Entradas Recargas Agentes',
    'Valor Entradas Recargas Agentes': 'Valor de Entradas Recargas Agentes',
    'Configuración Tabla': 'Configuração da tabela',
    'Premio Pagado': 'Prêmio pago',
    'No tiene permitido esta acción': 'Esta ação não é permitida',
    'Añadir bono masivo': 'Adicionar bônus massivo',
    'Tipo Transferencia': 'Tipo de transferência',
    'Tipo Reporte': 'Tipo de Reporte',
    'GGR. Deportivas': 'GGR. Esportes',
    'GGR. Casino': 'GGR. Cassino',
    Tipo: 'Tipo',
    'Sucursal bancaria': 'Agência bancária',
    'Tipo de ajuste': 'Tipo de ajuste',
    Fraude: 'Fraude',
    'Traslado usuario inactivado': 'Usuário de transferência inativado',
    Redondeo: 'Arredondamento',
    'Apuestas erróneas casino': 'Apostas erradas no cassino',
    Pruebas: 'Testes',
    Otros: 'Outros',
    'Cedula de Ciudadania': 'CPF',
    'Cedula de Extranjeria': 'Carteira de Motorista',
    'Recargas Anuladas': 'Recargas Canceladas',
    'Id punto de venta': 'ID da loja',
    'Nombre punto de venta': 'Nome da loja',
    'Reportes personalizados': 'Relatórios personalizados',
    Generado: 'Gerado',
    'Cantidad Registros': 'Número de Registros',
    'Solicitar Reporte': 'Solicitar relatório',
    'Link Reporte': 'Link Relatório',
    'Reporte solicitado corretamente': 'Relatório solicitado com sucesso',
    'Buscar Permiso': 'Permissão de pesquisa',
    Usuario: 'Usuário',
    Global: 'Global',
    Operación: 'Operação',
    'Tipo de acción': 'Tipo de ação',
    Autorizaciones: 'Autorizações',
    Bloqueos: 'Bloqueios',
    'Desea rechazar notas de retiro seleccionadas?': 'Você quer rejeitar notas de retirada selecionadas?',
    'Rechazar Notas': 'Notas Rejeitadas',
    'Notas de retiro rechazadas': 'Notas de retirada rejeitadas',
    'Seleccione por lo menos una nota de retiro para rechazar':
        'Selecione pelo menos uma nota de retirada para rejeitar',
    Sitio: 'Site',
    'Anular Transferencia': 'Cancelar Transferência',
    'Transferencia Anulada': 'Transferência Cancelada',
    'Monto y confirmar monto no coinciden': 'Valor e confirmar o Valor não correspondem',
    'Olvidó su contraseña?': 'Esqueceu sua senha?',
    'Se ha enviado correctamente el mensaje, te llegará un correo electrónico con la información.':
        'A mensagem foi enviada corretamente, você receberá um e-mail com a informação.',
    'Email Inválido': 'E-mail inválido',
    'Mínimo 8 caracteres, una minúscula, una mayúscula y un número.':
        'Mínimo 8 caracteres, uma minúscula, uma maiúscula e um número.',
    'Contraseña cambiada satisfactoriamente': 'Senha mudada com sucesso',
    'Nueva contraseña y confirmar contraseña no coinciden': 'Nova senha e confirmar senha não coincidem',
    'Nro. de Usuario:': 'Número de usuário:',
    'Nombre del Usuario:': 'Nome do usuário:',
    'Reporte bonos redimidos': 'Relatório de bônus resgatados',
    'Fecha Redimió': 'Data do resgate',
    ERROR10001: 'Há uma transacção para o fornecedor',
    ERROR10002: 'Negative amount',
    ERROR10003: 'Valor do bilhete diferente do rollback',
    ERROR10004: 'Débito com retrocesso antes',
    ERROR10005: 'A transacção não existe',
    ERROR10006: 'A transacção não é débito',
    ERROR10007: 'Os detalhes da transação não correspondem',
    ERROR10008: 'Valor de transação anterior diferente',
    ERROR10009: '',
    ERROR10010: 'A transação do jogo existe',
    ERROR10011: 'Token vazia',
    ERROR10012: 'O Token já existe',
    ERROR10013: 'UID vazio',
    ERROR10014: '# Débito diferente de # Crédito',
    ERROR10015: 'Transação com rollback',
    ERROR10016: 'Redonda fechada',
    ERROR10017: 'Moeda Incorreta',
    ERROR10018: 'Código de país errado',
    ERROR10019: '',
    ERROR10020: 'Empty field',
    ERROR10021: 'ID do usuário vazio',
    ERROR10022: '',
    ERROR10023: '',
    ERROR10024: '',
    ERROR10025: 'ID de bilhete já existe',
    ERROR10026: 'Ticket ID does not exist',
    ERROR10030: 'Token Inativo',
    ERROR10031: 'BettypeID Ezugi Errado',
    ERROR10027: 'O bilhete já está fechado',
    ERROR19000: 'A identificação já existe',
    ERROR19001: 'O login já está registrado',
    ERROR20000: 'Sessão do usuário expirada ou inválida',
    ERROR20001: 'Fundos insuficiente',
    ERROR20002: 'SINAL Errado',
    ERROR20003: 'Usuário inativo',
    ERROR20004: 'Auto-exclusão no produto interno de cassino',
    ERROR20005: 'Auto-exclusão na Categoria Cassino',
    ERROR20006: 'Auto-exclusão na SubCategoria Cassino',
    ERROR20007: 'Auto-exclusão nos jogos de cassino',
    ERROR20008: 'Limite de depósito simples',
    ERROR20009: 'Limite de depósito diário',
    ERROR20010: 'Limite de depósito semanal',
    ERROR20011: 'Limite de depósito mensal',
    ERROR20012: 'Limite anual de depósito',
    ERROR20013: 'Limite simples de cassino',
    ERROR20014: 'Limite Diário do Casino',
    ERROR20015: 'Limite Semanal do casino',
    ERROR20016: 'Limite Mensal do Casino',
    ERROR20017: 'Limite Anual do Casino',
    ERROR20018: 'Limite Simples do Casino Live',
    ERROR20019: 'Limite Diário do Casino Live',
    ERROR20020: 'Limite semanal do Casino Live',
    ERROR20021: 'Limite Mensal do Casino Live',
    ERROR20023: 'Limite Anual do Casino Live',
    ERROR20023: 'Casino Inactivo',
    ERROR20024: 'Casino em Contingência',
    ERROR20025: 'LiveCasino Inactivo',
    ERROR20026: 'LiveCasino em Contingência',
    ERROR20027: 'Utilizador total auto-excluído pelo tempo',
    ERROR20028: 'Utilizador total auto-excluído',
    ERROR20029: 'O utilizador não está registado na plataforma (Eliminado)',
    ERROR21000: 'O número de retirada não é encontrado',
    ERROR21001: 'A retirada já foi processada',
    ERROR21002: 'Valor inferior ao mínimo permitido para retirar',
    ERROR21003: 'Valor maior que o máximo permitido para retirar',
    ERROR21004: 'A conta precisa de ser verificada para poder ser retirada',
    ERROR21005: 'O registo deve ser aprovado para poder ser retirado',
    ERROR21006: 'A conta precisa de ser verificada para poder depositar',
    ERROR21007: 'O registo deve ser aprovado para poder depositar',
    ERROR21008: 'Valor inferior ao mínimo permitido para depósito',
    ERROR21009: 'Valor superior ao máximo permitido para depósito',
    ERROR21010: 'Produto não avilável',
    ERROR21011: 'Tem o número máximo de notas de retirada activas permitido',
    ERROR30001: 'Utilizador Bloqueado por número mínimo de logins incorrectos',
    ERROR30002: 'Usuário (Login) não existe',
    ERROR30003: 'Login com palavra-passe incorrecta',
    ERROR30004: 'Neste momento, estamos no processo de manutenção do site',
    ERROR30005: 'Usuário com registro inativo',
    ERROR30006: 'Usuário excede o número de contas bancárias registradas permitido',
    ERROR30007: 'A senha digitada está incorreta',
    ERROR30008: 'O código do voucher inserido está incorreto',
    ERROR30009: 'Carteira não configurada -> QUISK',
    ERROR30010: 'Você não pode entrar no site',
    ERROR30011: 'O usuário não corresponde ao token',
    ERROR30012: 'A Id do jogador não foi encontrada para a Id da rodada',
    ERROR30013: 'O jogo não foi encontrado para o Id rodada',
    ERROR30014: 'O Id do usuário é diferente do Id do usuário da Aposta que precisava ser cancelada',
    ERROR30015: '',
    ERROR30017: 'A rodada já foi completada',
    ERROR30018: 'A rodada já foi completada',
    ERROR30020: '',
    ERROR30021: '',
    ERROR50001: '',
    ERROR50002: 'Bônus de Fidelidade não disponível',
    ERROR50030: 'A rodada já foi completada',
    ERROR60001: '',
    ERROR60002: 'Erro nos dados enviados',
    ERROR60003: 'O pedido para o cliente estava vazio',
    ERROR100000: '',
    ERROR100001: 'debitTransaction em Ezugi está vazia',
    ERROR100002: '',
    ERROR100003: 'Rejeitado pela Automação',
    ERROR100004: 'Precisa de aprovação por automação',
    ERRO100005: 'O usuário não pertence ao parner',
    ERROR100010: '',
    ERROR100011: '',
    ERROR100012: 'Erro Geral',
    ERROR100013: 'Erro nos parâmetros enviados',
    ERROR100030: 'O ponto de venda não tem espaço disponível para recarregar',
    'Fecha de creación punto de venta': 'Data de criação da loja',
    Categorización: 'Categorização',
    'Categorización masiva': 'Categorização em massa',
    'Con Eliminadas?': 'Com eliminadas?',
    'Historial de puntos': 'Histórico de pontos',
    'Reporte de puntos lealtad': 'Relatório de Pontos de Fidelidade',
    'Usuario Aprueba': 'O usuário aprova',
    Acciones: 'Ações',
    'Nombre del documento': 'Nome do documento',
    'Tipo de documento': 'Tipo de documento',
    'Fecha de carga': 'Data de carregamento',
    'Cantidad de perfiles autorizados': 'Quantidade de perfis autorizados',
    'Visualizar archivo': 'Visualizar arquivo',
    'Cargando...': 'Carregando...',
    'No se pudo obtener el archivo': 'Não foi possível obter o arquivo',
    'Archivo actual: ': 'Arquivo atual: ',
    'Archivo seleccionado: ': 'Arquivo selecionado: ',
    '¿Desea inactivar el documento?': 'Deseja inativar o documento?',
    'Documento creado correctamente.': 'Documento criado com sucesso.',
    'Documento actualizado correctamente.': 'Documento atualizado com sucesso.',
    'Archivo reemplazado correctamente.': 'Arquivo substituído com sucesso.',
    'Documento inactivado correctamente.': 'Documento inativado com sucesso.',
    'No se pudo obtener el documento': 'Não foi possível obter o documento',
    'Vista previa no disponible, descarga el archivo': 'Pré-visualização indisponível, baixe o arquivo',
    'Vista previa no disponible': 'Pré-visualização indisponível',
    'No se pudo aceptar el documento, intenta nuevamente.': 'Não foi possível aceitar o documento, tente novamente.',
    'No se pudo cargar el documento, intenta nuevamente más tarde.': 'Não foi possível carregar o documento, tente novamente mais tarde.',
    'Archivo': 'Arquivo',
    'Cargar Archivo': 'Carregar Arquivo',
    'Debes adjuntar un archivo': 'Você deve anexar um arquivo',
    'El formato del archivo no es válido': 'O formato do arquivo não é válido',
    'El tamaño máximo permitido es de 5MB': 'O tamanho máximo permitido é de 5MB',
    'perfiles seleccionados': 'perfis selecionados',
    Documentos: 'Documentos',
    'Fecha de publicación': 'Data de publicação',
    'Tipo de acceso': 'Tipo de acesso',
};

// FILE DOCUMENTED
